import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BsPlus, BsLayoutTextSidebar, BsThreeDotsVertical } from 'react-icons/bs';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaLink } from 'react-icons/fa';
import { apiFetch, parseJsonSafe, API_URL } from '../utils/api';
import DOMPurify from 'dompurify';
import EmailEditor from '../components/EmailEditor';
import EmailMarketingJobsModal from './EmailMarketingJobsModal';

const EmailMarketingPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [activeTab, setActiveTab] = useState('campaigns');
  const [editorOpen, setEditorOpen] = useState(false);
  const [editorInitial, setEditorInitial] = useState(null);
  const [editorMode, setEditorMode] = useState('campaign');
  const [audiences, setAudiences] = useState([]);
  const [businessSectors, setBusinessSectors] = useState([]);
  const [audienceEmailSearch, setAudienceEmailSearch] = useState('');
  const [audienceEmailMatches, setAudienceEmailMatches] = useState(null);
  const [audienceEmailLoading, setAudienceEmailLoading] = useState(false);
  const [audienceEmailError, setAudienceEmailError] = useState('');
  const [manualAudienceId, setManualAudienceId] = useState('');
  const [manualContacts, setManualContacts] = useState({ total: 0, items: [] });
  const [manualContactForm, setManualContactForm] = useState({ name: '', email: '', phone: '' });
  const [manualMode, setManualMode] = useState(false);
  const [audienceFilters, setAudienceFilters] = useState({
    originTypes: [],
    clienteTipo: [],
    clienteEstado: [],
    businessSector: '',
    businessStatus: '',
    search: ''
  });
  const [contactsPreview, setContactsPreview] = useState({ total: 0, items: [] });
  const [audienceName, setAudienceName] = useState('');
  const [audienceDesc, setAudienceDesc] = useState('');
  const [campaigns, setCampaigns] = useState([]);
  const [selectedAudiences, setSelectedAudiences] = useState([]);
  const [editingCampaign, setEditingCampaign] = useState(null);
  const [previewData, setPreviewData] = useState(null);
  const [settings, setSettings] = useState({});
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsTab, setSettingsTab] = useState('branding');
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [emailAccounts, setEmailAccounts] = useState([]);
  const [defaultProvider, setDefaultProvider] = useState('smtp');
  const [stats, setStats] = useState({});
  const [jobsCampaignId, setJobsCampaignId] = useState(null);
  const [htmlPreview, setHtmlPreview] = useState(null);
  const [defaultAccountId, setDefaultAccountId] = useState('');
  const [templates, setTemplates] = useState([]);
  const [htmlImportOpen, setHtmlImportOpen] = useState(false);
  const [htmlImportSubject, setHtmlImportSubject] = useState('');
  const [htmlImportPreheader, setHtmlImportPreheader] = useState('');
  const [htmlImportBody, setHtmlImportBody] = useState('');
  const [htmlImportPreviewMode, setHtmlImportPreviewMode] = useState('desktop');
  const [htmlRenderPreview, setHtmlRenderPreview] = useState(null);
  const [htmlRenderPreviewMode, setHtmlRenderPreviewMode] = useState('desktop');
  const [createAudienceModal, setCreateAudienceModal] = useState(false);
  const [combineAudienceModal, setCombineAudienceModal] = useState(false);
  const [combineAudienceName, setCombineAudienceName] = useState('');
  const [combineAudienceDesc, setCombineAudienceDesc] = useState('');
  const [combineAudienceIds, setCombineAudienceIds] = useState([]);
  const [combineAudienceSearch, setCombineAudienceSearch] = useState('');
  const [combineAudienceEstimate, setCombineAudienceEstimate] = useState({ loading: false, total: 0 });
  const [combineAudienceSaving, setCombineAudienceSaving] = useState(false);
  const [manualContactModal, setManualContactModal] = useState(false);
  const [sendStepOpen, setSendStepOpen] = useState(false);
  const [sendStepCampaign, setSendStepCampaign] = useState(null);
  const [sendOptions, setSendOptions] = useState({
    provider: 'smtp',
    accountId: '',
    audiences: [],
    scheduleDate: '',
    scheduleTime: '',
    elasticSenderId: ''
  });
  const [campaignMenuOpenId, setCampaignMenuOpenId] = useState(null);
  const [resendModal, setResendModal] = useState({ open: false, campaign: null, candidates: 0, provider: 'smtp', accountId: '', elasticSenderId: '', subjectPrefix: '[Reenvío] ', sending: false });
  const [recipientEstimate, setRecipientEstimate] = useState({ loading: false, total: null, error: null });
  const normalizeDriveImageUrl = useCallback((value) => {
    if (!value) return '';
    const raw = String(value);
    if (!raw.includes('drive.google.com') && !raw.includes('drive.usercontent.google.com')) return raw;
    const match = raw.match(/\/file\/d\/([^/]+)/) || raw.match(/[?&]id=([^&]+)/);
    if (!match) return raw;
    return `/api/uploads/drive/${match[1]}`;
  }, []);
  const toAbsoluteUrl = useCallback((url) => {
    if (!url) return '';
    const normalized = normalizeDriveImageUrl(url);
    if (normalized.startsWith('http') || normalized.startsWith('//')) return normalized;
    if (API_URL) return `${API_URL}${normalized}`;
    try {
      return new URL(normalized, window.location.origin).toString();
    } catch (_e) {
      return normalized;
    }
  }, [normalizeDriveImageUrl]);
  const [testModal, setTestModal] = useState({ open: false, campaign: null, email: '', provider: 'smtp', accountId: '', elasticSenderId: '' });
  const [elasticSenders, setElasticSenders] = useState([]);
  const [sendersPanelOpen, setSendersPanelOpen] = useState(false);
  const [senderForm, setSenderForm] = useState({ id: null, name: '', from_email: '', from_name: '', reply_to: '', is_default: false });
  const loadElasticSenders = useCallback(async () => {
    try {
      const res = await apiFetch('/api/email-marketing/elastic-senders', { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) {
        const data = await parseJsonSafe(res);
        setElasticSenders(Array.isArray(data) ? data : []);
      }
    } catch (_) { /* noop */ }
  }, [token]);
  useEffect(() => { loadElasticSenders(); }, [loadElasticSenders]);
  const loadBusinessSectors = useCallback(async () => {
    try {
      const res = await apiFetch('/api/email-marketing/business/values', { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) {
        const data = await parseJsonSafe(res);
        setBusinessSectors(Array.isArray(data?.sectors) ? data.sectors : []);
      }
    } catch (_) { /* noop */ }
  }, [token]);
  useEffect(() => { loadBusinessSectors(); }, [loadBusinessSectors]);
  const previewSettings = useMemo(() => ({
    header_logo: toAbsoluteUrl(settings.header_logo || ''),
    header_bg: settings.header_bg || '#ffffff',
    header_text_color: settings.header_text_color || '#1f2937',
    footer_bg: settings.footer_bg || '#ffffff',
    footer_text_color: settings.footer_text_color || '#4b5563',
    header_text: settings.header_text || '',
    footer_text: settings.footer_text || '',
    unsubscribe_url: settings.unsubscribe_url || '',
    social_links: settings.social_links || {},
    header_layout: settings.header_layout || 'logo_left'
  }), [settings, toAbsoluteUrl]);

  const socialIcons = {
    facebook: <FaFacebook />,
    instagram: <FaInstagram />,
    linkedin: <FaLinkedin />,
    twitter: <FaTwitter />,
    default: <FaLink />
  };
  const hasHtml = (value) => /<\/?[a-z][\s\S]*>/i.test(String(value || ''));
  const escapeHtml = (str = '') => String(str).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[c]));
  const sanitizeTextHtml = (value) => {
    const raw = String(value || '');
    if (!raw) return '';
    if (!hasHtml(raw)) return escapeHtml(raw).replace(/\n/g, '<br/>');
    let html = raw;
    html = html.replace(/<\/(div|p)>/gi, '<br/>').replace(/<(div|p)(\s[^>]*)?>/gi, '');
    html = html.replace(/<br\s*\/?>/gi, '<br/>');
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'u', 'br', 'a'],
      ALLOWED_ATTR: ['href', 'target', 'rel']
    });
  };
  const htmlPlaceholders = [
    { key: 'tracking_pixel', token: '{{tracking_pixel}}', label: 'Tracking pixel' },
    { key: 'unsubscribe_url', token: '{{unsubscribe_url}}', label: 'Unsubscribe URL' },
    { key: 'preheader', token: '{{preheader}}', label: 'Preheader' },
    { key: 'name', token: '{{name}}', label: 'Nombre' },
    { key: 'email', token: '{{email}}', label: 'Email' }
  ];
  const hasPlaceholder = (html, key) => new RegExp(`{{\\s*${key}\\s*}}`, 'i').test(String(html || ''));
  const missingHtmlPlaceholders = useMemo(
    () => htmlPlaceholders.filter((p) => !hasPlaceholder(htmlImportBody, p.key)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [htmlImportBody]
  );
  const insertAfterBodyOpen = (html, snippet) => {
    const match = html.match(/<body[^>]*>/i);
    if (match) {
      return html.replace(match[0], `${match[0]}\n${snippet}`);
    }
    return `${snippet}\n${html}`;
  };
  const insertBeforeBodyClose = (html, snippet) => {
    if (/<\/body>/i.test(html)) {
      return html.replace(/<\/body>/i, `${snippet}\n</body>`);
    }
    return `${html}\n${snippet}`;
  };
  const injectHtmlPlaceholders = (html, missingKeys = []) => {
    let out = String(html || '');
    if (!out.trim()) return out;
    if (missingKeys.includes('preheader')) {
      out = insertAfterBodyOpen(
        out,
        '<div style="display:none;max-height:0;overflow:hidden;font-size:1px;line-height:1px;color:#ffffff;opacity:0">{{preheader}}</div>'
      );
    }
    const personalization = [];
    if (missingKeys.includes('name')) personalization.push('{{name}}');
    if (missingKeys.includes('email')) personalization.push('{{email}}');
    if (personalization.length) {
      out = insertAfterBodyOpen(out, `<!-- personalization: ${personalization.join(' ')} -->`);
    }
    if (missingKeys.includes('tracking_pixel')) {
      out = insertBeforeBodyClose(out, '{{tracking_pixel}}');
    }
    if (missingKeys.includes('unsubscribe_url')) {
      out = insertBeforeBodyClose(
        out,
        '<div style="text-align:center;font-size:12px;color:#888;margin-top:24px"><a href="{{unsubscribe_url}}" style="color:#888;text-decoration:underline">Darse de baja</a></div>'
      );
    }
    return out;
  };
  const buildHtmlPreview = (html, { preheader, unsubscribeUrl, name, email } = {}) => {
    let out = String(html || '');
    if (!out) return '';
    out = out.replace(/{{\s*tracking_pixel\s*}}/gi, '');
    out = out.replace(/{{\s*unsubscribe_url\s*}}/gi, unsubscribeUrl || '#');
    out = out.replace(/{{\s*preheader\s*}}/gi, preheader || '');
    out = out.replace(/{{\s*name\s*}}/gi, name || 'Cliente');
    out = out.replace(/{{\s*email\s*}}/gi, email || 'cliente@ejemplo.com');
    return out;
  };
  const normalizeHtmlForAnalysis = (value) => {
    let s = String(value || '');
    if (!s) return '';
    // Users sometimes paste "escaped" HTML (&lt;html&gt;) or fullwidth brackets (＜html＞).
    // Normalize so the analyzer can give actionable warnings instead of false negatives.
    s = s.replace(/\uFEFF/g, ''); // strip BOM if present
    s = s.replace(/[＜﹤]/g, '<').replace(/[＞﹥]/g, '>');
    const decodeAnglesOnce = (str) =>
      String(str || '')
        .replace(/&amp;lt;/gi, '<')
        .replace(/&amp;gt;/gi, '>')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&amp;#0*60;/gi, '<')
        .replace(/&amp;#0*62;/gi, '>')
        .replace(/&amp;#x0*3c;/gi, '<')
        .replace(/&amp;#x0*3e;/gi, '>')
        .replace(/&#0*60;/gi, '<')
        .replace(/&#0*62;/gi, '>')
        .replace(/&#x0*3c;/gi, '<')
        .replace(/&#x0*3e;/gi, '>');
    // Decode twice to handle common double-escaping (&amp;lt;).
    s = decodeAnglesOnce(decodeAnglesOnce(s));
    return s;
  };
  const analyzeHtmlTemplate = (html) => {
    const rawInput = String(html || '');
    const raw = normalizeHtmlForAnalysis(rawInput);
    if (!raw.trim()) return { errors: [], warnings: [] };
    const warnings = [];
    const errors = [];

    if (!/<html\b/i.test(rawInput) && /<html\b/i.test(raw)) {
      warnings.push('El HTML parece estar escapado o contiene caracteres especiales (ej: &lt;html&gt; o ＜html＞). Pega el HTML "tal cual", con < y > reales.');
    }

    const tagCount = (tag, closing = false) => {
      const pattern = closing ? `</${tag}\\b` : `<${tag}\\b`;
      return (raw.match(new RegExp(pattern, 'gi')) || []).length;
    };
    if (!/<!doctype\s+html>/i.test(raw)) warnings.push('Falta <!DOCTYPE html>.');
    if (!/<html\b/i.test(raw)) warnings.push('Falta etiqueta <html>.');
    if (!/<head\b/i.test(raw)) warnings.push('Falta etiqueta <head>.');
    if (!/<body\b/i.test(raw)) warnings.push('Falta etiqueta <body>.');
    if (/<html\b/i.test(raw) && !/<\/html>/i.test(raw)) warnings.push('Falta </html>.');
    if (/<head\b/i.test(raw) && !/<\/head>/i.test(raw)) warnings.push('Falta </head>.');
    if (/<body\b/i.test(raw) && !/<\/body>/i.test(raw)) warnings.push('Falta </body>.');
    if (!/<meta[^>]+charset=/i.test(raw)) warnings.push('Falta <meta charset="utf-8">.');
    if (!/<meta[^>]+viewport/i.test(raw)) warnings.push('Falta <meta name="viewport"> (móvil).');
    if (tagCount('html') > 1) warnings.push('Hay más de un <html>.');
    if (tagCount('head') > 1) warnings.push('Hay más de un <head>.');
    if (tagCount('body') > 1) warnings.push('Hay más de un <body>.');
    if (/<script\b/i.test(raw)) errors.push('Se detectó <script> (no permitido en emails).');
    if (/<iframe\b/i.test(raw)) warnings.push('Se detectó <iframe> (la mayoría de clientes lo bloquean).');
    if (/<form\b/i.test(raw) || /<input\b/i.test(raw) || /<button\b/i.test(raw)) {
      warnings.push('Se detectaron formularios/inputs/botones (no suelen funcionar en emails).');
    }
    if (/<link\b[^>]*rel=['"]?stylesheet/i.test(raw)) warnings.push('CSS externo con <link> puede ser bloqueado.');
    if (/<style\b/i.test(raw)) warnings.push('Hay <style>; algunos clientes requieren CSS inline.');
    return { errors, warnings };
  };
  const htmlImportAnalysis = useMemo(
    () => analyzeHtmlTemplate(htmlImportBody),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [htmlImportBody]
  );
  const renderHtmlFrame = (html, mode = 'desktop') => {
    const width = mode === 'mobile' ? 375 : 700;
    const height = mode === 'mobile' ? 640 : 720;
    return (
      <div style={{ background: '#eef1f5', padding: 12, borderRadius: 8 }}>
        <div style={{ width, margin: '0 auto', background: '#fff', borderRadius: 6, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
          <iframe
            title={`preview-${mode}`}
            srcDoc={html || ''}
            style={{ width: '100%', height, border: 'none', display: 'block' }}
            sandbox=""
            referrerPolicy="no-referrer"
          />
        </div>
      </div>
    );
  };

  const renderHeaderPreview = () => {
    const headerLogo = previewSettings.header_logo;
    const headerText = (previewSettings.header_text || '').trim();
    const hasHeaderLogo = Boolean(headerLogo);
    const hasHeaderText = Boolean(headerText);
    const hasHeader = hasHeaderLogo || hasHeaderText;
    if (!hasHeader) return null;
    const stacked = previewSettings.header_layout === 'stacked_center';
    const display = stacked ? 'block' : (hasHeaderLogo && hasHeaderText ? 'flex' : 'block');
    const textAlign = stacked ? 'center' : 'left';
    return (
      <div
        style={{
          background: previewSettings.header_bg,
          padding: '12px 16px',
          borderBottom: '1px solid #e9ecef',
          display,
          alignItems: display === 'flex' ? 'center' : undefined,
          gap: 12,
          textAlign
        }}
      >
        {hasHeaderLogo && (
          <div style={{ display: 'flex', justifyContent: stacked ? 'center' : 'flex-start' }}>
            <img
              src={headerLogo}
              alt="Logo"
              style={{ maxHeight: 48, maxWidth: 140, objectFit: 'contain', margin: stacked ? '0 auto' : '0' }}
            />
          </div>
        )}
        {hasHeaderText && (
          <div
            style={{
              fontWeight: 600,
              color: previewSettings.header_text_color || '#1f2937',
              whiteSpace: 'pre-line',
              marginTop: stacked && hasHeaderLogo ? 6 : 0
            }}
          >
            {headerText}
          </div>
        )}
      </div>
    );
  };

  const renderFooterPreview = () => {
    const footerText = (previewSettings.footer_text || '').trim();
    const links = Object.entries(previewSettings.social_links || {}).filter(([, v]) => v);
    const hasLinks = links.length > 0;
    const unsubscribeUrl = previewSettings.unsubscribe_url || '';
    const hasFooter = Boolean(footerText) || hasLinks || Boolean(unsubscribeUrl);
    if (!hasFooter) return null;
    return (
      <div
        style={{
          background: previewSettings.footer_bg,
          padding: '12px 16px',
          borderTop: '1px solid #e9ecef',
          color: previewSettings.footer_text_color || '#4b5563',
          textAlign: 'center'
        }}
      >
        {footerText && (
          <div style={{ marginBottom: hasLinks || unsubscribeUrl ? 6 : 0, whiteSpace: 'pre-line' }}>
            {footerText}
          </div>
        )}
        {hasLinks && (
          <div className="d-flex gap-3 flex-wrap small align-items-center justify-content-center">
            {links.map(([k, v]) => (
              <a
                key={k}
                href={v}
                target="_blank"
                rel="noreferrer"
                className="d-flex align-items-center gap-1"
                style={{ textDecoration: 'none', color: previewSettings.footer_text_color || '#ffffff' }}
              >
                {socialIcons[k] || socialIcons.default}
                <span className="small">{k}</span>
              </a>
            ))}
          </div>
        )}
        {unsubscribeUrl && (
          <div className={footerText || hasLinks ? 'mt-2' : undefined}>
            <a
              href={unsubscribeUrl}
              target="_blank"
              rel="noreferrer"
              className="small"
              style={{ color: previewSettings.footer_text_color || '#ffffff' }}
            >
              Darse de baja
            </a>
          </div>
        )}
      </div>
    );
  };

  const renderSettingsPreview = () => (
    <div className="border rounded shadow-sm" style={{ background: '#f8f9fb' }}>
      {renderHeaderPreview()}
      <div style={{ padding: '16px 18px', background: '#ffffff' }}>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>Ejemplo de asunto</div>
        <div style={{ color: '#555', marginBottom: 14 }}>Preheader de ejemplo para ver tamaño y fuente</div>
        <p style={{ marginBottom: 8, color: '#1f2937' }}>Hola, este es un preview rápido de cómo se vería el cuerpo de tu email.</p>
        <p style={{ marginBottom: 0, color: '#1f2937' }}>Puedes ajustar logo, colores y textos a la izquierda.</p>
      </div>
      {renderFooterPreview()}
    </div>
  );

  const saveSettings = async () => {
    try {
      const res = await apiFetch('/api/email-marketing/settings', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(settings)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar configuración');
      setSettings(data);
      setSettingsOpen(false);
      alert('Configuración guardada');
    } catch (err) {
      alert(err.message);
    }
  };

  const clearAudienceSearch = () => setAudienceEmailSearch('');

  const nextScheduleDefaults = () => {
    const d = new Date();
    d.setMinutes(d.getMinutes() + 30);
    return { date: d.toISOString().slice(0, 10), time: d.toTimeString().slice(0, 5) };
  };

  const resolveTrackingBaseUrl = () => {
    const raw = (API_URL || '').trim();
    if (/^https?:\/\//i.test(raw)) return raw.replace(/\/$/, '').replace(/\/api\/?$/i, '');
    const origin = window.location.origin.replace(/\/$/, '');
    if (!raw) return origin;
    const path = raw.replace(/^\/+/, '').replace(/\/$/, '').replace(/\/api\/?$/i, '');
    return `${origin}/${path}`;
  };

  const toLocalDateTimeInputs = (isoString) => {
    if (!isoString) return null;
    const d = new Date(isoString);
    if (Number.isNaN(d.getTime())) return null;
    const pad = (n) => String(n).padStart(2, '0');
    return {
      date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
      time: `${pad(d.getHours())}:${pad(d.getMinutes())}`
    };
  };

  const getCampaignUiStatus = (campaign) => {
    const status = campaign?.status || '';
    const jobsTotal = Number(campaign?.jobs_total || 0);

    if (status === 'borrador') return { label: 'BORRADOR', badge: 'secondary' };
    if (status === 'cancelada') return { label: 'CANCELADA', badge: 'dark' };
    if (status === 'enviada') return { label: 'ENVIADA', badge: 'success' };
    if (campaign?.scheduled_at && jobsTotal === 0) return { label: 'PROGRAMADA', badge: 'info' };
    if (jobsTotal > 0) return { label: 'ENVIÁNDOSE', badge: 'primary' };
    if (status === 'programada') return { label: 'ENVIÁNDOSE', badge: 'primary' };
    return { label: status ? status.toUpperCase() : '—', badge: 'secondary' };
  };

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('userEmail');
    window.location.href = '/login';
  };

  useEffect(() => {
    if (!campaignMenuOpenId) return undefined;
    const onDocClick = () => setCampaignMenuOpenId(null);
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [campaignMenuOpenId]);

  const fetchAudiences = async () => {
    try {
      const res = await apiFetch('/api/email-marketing/audiences', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok && Array.isArray(data)) setAudiences(data);
    } catch (err) {
      console.error('Error cargando audiencias', err);
    }
  };

  const fetchContacts = async (customFilters) => {
    if (manualMode) {
      setContactsPreview({ total: 0, items: [] });
      return;
    }
    const qs = new URLSearchParams();
    const f = customFilters || audienceFilters;
    if (f.originTypes.length) qs.append('originTypes', f.originTypes.join(','));
    if (f.clienteTipo.length) qs.append('clienteTipo', f.clienteTipo.join(','));
    if (f.clienteEstado.length) qs.append('clienteEstado', f.clienteEstado.join(','));
    if (f.businessSector) qs.append('businessSector', f.businessSector);
    if (f.businessStatus) qs.append('businessStatus', f.businessStatus);
    if (f.search) qs.append('search', f.search);
    qs.append('limit', '200');
    try {
      const res = await apiFetch(`/api/email-marketing/contacts?${qs.toString()}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok) setContactsPreview(data);
    } catch (err) {
      console.error('Error obteniendo contactos', err);
    }
  };

  const saveAudience = async () => {
    if (!audienceName) return alert('Pon un nombre a la audiencia');
    const filters = manualMode ? { originTypes: ['manual'] } : { ...audienceFilters };
    try {
      const res = await apiFetch('/api/email-marketing/audiences', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ name: audienceName, description: audienceDesc, filters })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la audiencia');
      setAudienceName('');
      setAudienceDesc('');
      fetchAudiences();
      if (data?.id && manualMode) {
        setManualAudienceId(data.id.toString());
        fetchManualContacts(data.id);
      }
      alert('Audiencia guardada');
    } catch (err) {
      alert(err.message);
    }
  };

  const saveCombinedAudience = async () => {
    if (!combineAudienceName.trim()) return alert('Pon un nombre a la audiencia combinada');
    if (combineAudienceIds.length < 1) return alert('Selecciona al menos una audiencia');
    setCombineAudienceSaving(true);
    try {
      const res = await apiFetch('/api/email-marketing/audiences/combined', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          name: combineAudienceName.trim(),
          description: combineAudienceDesc.trim(),
          audienceIds: combineAudienceIds
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo crear la audiencia combinada');
      alert(`Audiencia combinada creada. Contactos importados: ${data.imported || 0}`);
      const newId = data?.audience?.id || data?.id;
      setCombineAudienceName('');
      setCombineAudienceDesc('');
      setCombineAudienceIds([]);
      setCombineAudienceSearch('');
      setCombineAudienceModal(false);
      fetchAudiences();
      if (newId) {
        navigate(`/email-marketing/audiencias/${newId}`, { state: { audience: data.audience } });
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setCombineAudienceSaving(false);
    }
  };

  const fetchCampaigns = async () => {
    try {
      const res = await apiFetch('/api/email-marketing/campaigns', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok && Array.isArray(data)) setCampaigns(data);
    } catch (err) {
      console.error('Error cargando campañas', err);
    }
  };
  const fetchTemplates = async () => {
    try {
      const res = await apiFetch('/api/email-marketing/templates', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (Array.isArray(data)) setTemplates(data);
    } catch (err) {
      console.error('Error cargando plantillas', err);
    }
  };
  const fetchAccounts = async () => {
    try {
      const res = await apiFetch('/api/email-accounts', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (Array.isArray(data)) setEmailAccounts(data.filter((a) => a.active));
    } catch (err) {
      console.error('Error cargando cuentas email', err);
    }
  };
  const fetchStats = async (id) => {
    try {
      const res = await apiFetch(`/api/email-marketing/campaigns/${id}/stats`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok) setStats((p) => ({ ...p, [id]: data }));
    } catch (err) {
      console.error('Error cargando stats', err);
    }
  };

  const fetchSettings = async () => {
    try {
      const res = await apiFetch('/api/email-marketing/settings', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok) setSettings(data || {});
    } catch (err) {
      console.error('Error cargando configuración email marketing', err);
    }
  };

  const fetchManualContacts = async (audId) => {
    if (!audId) {
      setManualContacts({ total: 0, items: [] });
      return;
    }
    try {
      const res = await apiFetch(`/api/email-marketing/audiences/${audId}/contacts?mode=manual&limit=500`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.ok) setManualContacts(data);
    } catch (err) {
      console.error('Error cargando contactos manuales', err);
    }
  };

  const addManualContact = async () => {
    if (!manualAudienceId) return alert('Selecciona una audiencia');
    if (!manualContactForm.email) return alert('Email es obligatorio');
    try {
      const res = await apiFetch(`/api/email-marketing/audiences/${manualAudienceId}/contacts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(manualContactForm)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (res.status === 409) throw new Error(data.message || 'Contacto ya existente en audiencia');
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar');
      setManualContactForm({ name: '', email: '', phone: '' });
      fetchManualContacts(manualAudienceId);
    } catch (err) {
      alert(err.message);
    }
  };

  const deleteManualContact = async (id) => {
    if (!manualAudienceId) return;
    if (!window.confirm('¿Eliminar este contacto manual?')) return;
    try {
      const res = await apiFetch(`/api/email-marketing/audiences/${manualAudienceId}/contacts/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error('No se pudo eliminar');
      fetchManualContacts(manualAudienceId);
    } catch (err) {
      alert(err.message);
    }
  };

  const toggleSendAudience = (id) => {
    setSendOptions((prev) => {
      const exists = prev.audiences.includes(id);
      return { ...prev, audiences: exists ? prev.audiences.filter((x) => x !== id) : [...prev.audiences, id] };
    });
  };

  const handleSendNow = async () => {
    if (!sendStepCampaign) return;
    if (!sendOptions.audiences.length) return alert('Selecciona al menos una audiencia');
    if (sendOptions.provider === 'smtp' && !sendOptions.accountId) return alert('Selecciona una cuenta SMTP');
    try {
      // Persist selected elastic sender on the campaign so the send loop lo lea
      if (sendOptions.provider === 'elastic') {
        await apiFetch(`/api/email-marketing/campaigns/${sendStepCampaign.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ elastic_sender_id: sendOptions.elasticSenderId || null })
        });
      }
      const sendRes = await apiFetch(`/api/email-marketing/campaigns/${sendStepCampaign.id}/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          mode: 'now',
          provider: sendOptions.provider,
          accountId: sendOptions.accountId,
          audience_ids: sendOptions.audiences,
          tracking_base_url: resolveTrackingBaseUrl(),
          batchSize: 50
        })
      });
      const sendData = await parseJsonSafe(sendRes);
      if (sendRes.status === 401) return handleUnauthorized();
      if (!sendRes.ok) throw new Error(sendData.message || 'No se pudo enviar');

      alert(`Envío iniciado: encolados ${sendData.queued || 0}, procesados ${sendData.processed || 0}`);
      setSendStepOpen(false);
      fetchCampaigns();
      fetchStats(sendStepCampaign.id);
    } catch (err) {
      alert(err.message);
    }
  };

  const handleSaveDraftSendStep = async () => {
    if (!sendStepCampaign) return;
    try {
      const resUpdate = await apiFetch(`/api/email-marketing/campaigns/${sendStepCampaign.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          audience_ids: sendOptions.audiences,
          default_provider: sendOptions.provider,
          default_account_id: sendOptions.accountId ? Number(sendOptions.accountId) : null,
          elastic_sender_id: sendOptions.elasticSenderId || null,
          status: 'borrador',
          scheduled_at: null
        })
      });
      const dataUpdate = await parseJsonSafe(resUpdate);
      if (resUpdate.status === 401) return handleUnauthorized();
      if (!resUpdate.ok) throw new Error(dataUpdate.message || 'No se pudo guardar borrador');
      alert('Campaña guardada en borrador');
      setSendStepOpen(false);
      fetchCampaigns();
    } catch (err) {
      alert(err.message);
    }
  };

  const handleScheduleSend = async () => {
    if (!sendStepCampaign) return;
    if (!sendOptions.audiences.length) return alert('Selecciona al menos una audiencia');
    if (sendOptions.provider === 'smtp' && !sendOptions.accountId) return alert('Selecciona una cuenta SMTP');
    if (!sendOptions.scheduleDate || !sendOptions.scheduleTime) return alert('Selecciona fecha y hora');
    const scheduledAt = new Date(`${sendOptions.scheduleDate}T${sendOptions.scheduleTime}:00`);
    if (Number.isNaN(scheduledAt.getTime())) return alert('Fecha u hora no válida');
    try {
      if (sendOptions.provider === 'elastic') {
        await apiFetch(`/api/email-marketing/campaigns/${sendStepCampaign.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ elastic_sender_id: sendOptions.elasticSenderId || null })
        });
      }
      const resUpdate = await apiFetch(`/api/email-marketing/campaigns/${sendStepCampaign.id}/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          mode: 'schedule',
          provider: sendOptions.provider,
          accountId: sendOptions.accountId,
          audience_ids: sendOptions.audiences,
          scheduled_at: scheduledAt.toISOString(),
          tracking_base_url: resolveTrackingBaseUrl()
        })
      });
      const dataUpdate = await parseJsonSafe(resUpdate);
      if (resUpdate.status === 401) return handleUnauthorized();
      if (!resUpdate.ok) throw new Error(dataUpdate.message || 'No se pudo programar campaña');
      alert('Campaña programada');
      setSendStepOpen(false);
      fetchCampaigns();
    } catch (err) {
      alert(err.message);
    }
  };

  useEffect(() => {
    fetchAudiences();
    fetchCampaigns();
    fetchSettings();
    fetchAccounts();
    fetchTemplates();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (manualAudienceId) fetchManualContacts(manualAudienceId);
    else setManualContacts({ total: 0, items: [] });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manualAudienceId]);

  useEffect(() => {
    if (manualContactModal && manualAudienceId) fetchManualContacts(manualAudienceId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manualContactModal]);

  useEffect(() => {
    const term = audienceEmailSearch.trim();
    if (!term) {
      setAudienceEmailMatches(null);
      setAudienceEmailLoading(false);
      setAudienceEmailError('');
      return;
    }
    let canceled = false;
    setAudienceEmailLoading(true);
    setAudienceEmailError('');
    const timer = setTimeout(async () => {
      try {
        const res = await apiFetch(`/api/email-marketing/audiences/search?email=${encodeURIComponent(term)}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await parseJsonSafe(res);
        if (res.status === 401) return handleUnauthorized();
        if (!res.ok) throw new Error(data.message || 'Error buscando audiencias');
        if (canceled) return;
        setAudienceEmailMatches(Array.isArray(data.ids) ? data.ids : []);
      } catch (err) {
        if (canceled) return;
        setAudienceEmailMatches([]);
        setAudienceEmailError(err.message);
      } finally {
        if (!canceled) setAudienceEmailLoading(false);
      }
    }, 300);
    return () => {
      canceled = true;
      clearTimeout(timer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audienceEmailSearch]);

  useEffect(() => {
    if (!combineAudienceModal) return;
    if (!combineAudienceIds.length) {
      setCombineAudienceEstimate({ loading: false, total: 0 });
      return;
    }
    let canceled = false;
    setCombineAudienceEstimate({ loading: true, total: 0 });
    const timer = setTimeout(async () => {
      try {
        const res = await apiFetch('/api/email-marketing/recipients/estimate', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ audience_ids: combineAudienceIds })
        });
        const data = await parseJsonSafe(res);
        if (res.status === 401) return handleUnauthorized();
        if (!res.ok) throw new Error(data.message || 'Error estimando contactos');
        if (canceled) return;
        setCombineAudienceEstimate({ loading: false, total: Number(data.estimated_total || 0) });
      } catch (_err) {
        if (canceled) return;
        setCombineAudienceEstimate({ loading: false, total: 0 });
      }
    }, 300);
    return () => {
      canceled = true;
      clearTimeout(timer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combineAudienceIds, combineAudienceModal]);

  useEffect(() => {
    if (!sendStepOpen) {
      setRecipientEstimate({ loading: false, total: null, error: null });
      return;
    }
    if (!sendOptions.audiences.length) {
      setRecipientEstimate({ loading: false, total: 0, error: null });
      return;
    }

    let canceled = false;
    setRecipientEstimate({ loading: true, total: null, error: null });
    const timer = setTimeout(async () => {
      try {
        const res = await apiFetch('/api/email-marketing/recipients/estimate', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ audience_ids: sendOptions.audiences })
        });
        const data = await parseJsonSafe(res);
        if (res.status === 401) return handleUnauthorized();
        if (!res.ok) throw new Error(data.message || 'Error estimando destinatarios');
        if (canceled) return;
        setRecipientEstimate({ loading: false, total: Number(data.estimated_total || 0), error: null });
      } catch (err) {
        if (canceled) return;
        setRecipientEstimate({ loading: false, total: null, error: err.message });
      }
    }, 300);

    return () => {
      canceled = true;
      clearTimeout(timer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendStepOpen, JSON.stringify(sendOptions.audiences)]);

  const saveCampaign = async (design) => {
    const name = design?.subject?.trim() || 'Campaña sin nombre';
    const payload = {
      name,
      subject: design?.subject || '',
      preheader: design?.preheader || '',
      design_json: design || null,
      audience_ids: selectedAudiences,
      status: 'borrador',
      default_account_id: defaultAccountId ? Number(defaultAccountId) : null,
      default_provider: defaultProvider
    };
    const isEdit = Boolean(editingCampaign?.id);
    const url = isEdit ? `/api/email-marketing/campaigns/${editingCampaign.id}` : '/api/email-marketing/campaigns';
    const method = isEdit ? 'PUT' : 'POST';
    try {
      const res = await apiFetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la campaña');
      fetchCampaigns();
      setEditorOpen(false);
      setEditingCampaign(null);
      setSendStepCampaign(data);
      setSendOptions((prev) => ({
        ...prev,
        provider: payload.default_provider || defaultProvider || 'smtp',
        accountId: (payload.default_account_id || defaultAccountId || '').toString(),
        audiences: payload.audience_ids || [],
        scheduleDate: nextScheduleDefaults().date,
        scheduleTime: nextScheduleDefaults().time
      }));
      setSendStepOpen(true);
      alert(isEdit ? 'Campaña actualizada' : 'Campaña guardada. Configura el envío.');
    } catch (err) {
      alert(err.message);
    }
  };

  const saveTemplate = async (design) => {
    const name = design?.subject?.trim() || 'Plantilla sin nombre';
    try {
      const res = await apiFetch('/api/email-marketing/templates', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          name,
          subject: design?.subject || '',
          preheader: design?.preheader || '',
          design_json: design || null
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la plantilla');
      setEditorOpen(false);
      setEditorMode('campaign');
      fetchTemplates();
      alert('Plantilla guardada');
    } catch (err) {
      alert(err.message);
    }
  };

  const openHtmlImport = (campaign = null) => {
    setEditingCampaign(campaign);
    setHtmlImportSubject(campaign?.subject || '');
    setHtmlImportPreheader(campaign?.preheader || '');
    setHtmlImportBody(campaign?.html_body || '');
    setHtmlImportPreviewMode('desktop');
    setHtmlImportOpen(true);
  };

  const closeHtmlImport = () => {
    setHtmlImportOpen(false);
    setHtmlImportSubject('');
    setHtmlImportPreheader('');
    setHtmlImportBody('');
    setHtmlImportPreviewMode('desktop');
    setEditingCampaign(null);
  };

  const saveHtmlCampaign = async () => {
    const subject = htmlImportSubject.trim();
    const name = subject || 'Campaña sin nombre';
    const html = String(htmlImportBody || '').trim();
    if (!html) return alert('El HTML es obligatorio');
    if (htmlImportAnalysis.errors.length) {
      const items = htmlImportAnalysis.errors.join('\n');
      if (!window.confirm(`Se detectaron problemas en el HTML:\\n${items}\\n\\n¿Guardar igualmente?`)) return;
    }
    if (missingHtmlPlaceholders.length) {
      const tokens = missingHtmlPlaceholders.map((p) => p.token).join(', ');
      if (!window.confirm(`Faltan placeholders: ${tokens}. ¿Guardar igualmente?`)) return;
    }
    const payload = {
      name,
      subject,
      preheader: htmlImportPreheader || '',
      content_mode: 'html',
      html_body: html,
      audience_ids: selectedAudiences,
      status: 'borrador',
      default_account_id: defaultAccountId ? Number(defaultAccountId) : null,
      default_provider: defaultProvider
    };
    const isEdit = Boolean(editingCampaign?.id);
    const url = isEdit ? `/api/email-marketing/campaigns/${editingCampaign.id}` : '/api/email-marketing/campaigns';
    const method = isEdit ? 'PUT' : 'POST';
    try {
      const res = await apiFetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload)
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo guardar la campaña');
      fetchCampaigns();
      closeHtmlImport();
      setSendStepCampaign(data);
      setSendOptions((prev) => ({
        ...prev,
        provider: payload.default_provider || defaultProvider || 'smtp',
        accountId: (payload.default_account_id || defaultAccountId || '').toString(),
        audiences: payload.audience_ids || [],
        scheduleDate: nextScheduleDefaults().date,
        scheduleTime: nextScheduleDefaults().time
      }));
      setSendStepOpen(true);
      alert(isEdit ? 'Campaña actualizada' : 'Campaña guardada. Configura el envío.');
    } catch (err) {
      alert(err.message);
    }
  };

  const openTestModal = (campaign) => {
    const fallbackAcc = campaign?.default_account_id
      ? String(campaign.default_account_id)
      : (emailAccounts[0]?.id ? String(emailAccounts[0].id) : '');
    setTestModal({
      open: true,
      campaign,
      email: '',
      provider: campaign?.default_provider || 'smtp',
      accountId: fallbackAcc
    });
  };

  const handleSendTest = async () => {
    const { campaign, email, provider, accountId, elasticSenderId } = testModal;
    if (!campaign) return;
    if (!email) return alert('Indica el email de test');
    if (provider === 'smtp' && !accountId) return alert('Selecciona una cuenta SMTP');
    try {
      const res = await apiFetch(`/api/email-marketing/campaigns/${campaign.id}/send-test`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          to: email,
          accountId: provider === 'smtp' ? accountId : null,
          provider,
          elastic_sender_id: provider === 'elastic' ? (elasticSenderId || null) : null,
          tracking_base_url: resolveTrackingBaseUrl()
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error enviando test');
      alert('Test enviado');
      setTestModal((p) => ({ ...p, open: false }));
    } catch (err) {
      alert(err.message);
    }
  };

  const audienceNameById = (id) => audiences.find((a) => a.id === id)?.name || id;
  const filteredAudiences = audienceEmailMatches
    ? audiences.filter((a) => audienceEmailMatches.includes(a.id))
    : audiences;
  // Las audiencias se agrupan por el prefijo del nombre ("Grupo · Nombre"). Los grupos
  // grandes (Sector, Captación) empiezan plegados.
  const [openGroups, setOpenGroups] = useState({});
  const audienceGroups = useMemo(() => {
    const order = ['Clientes', 'Global', 'Prospectos', 'CMS', 'Sector', 'Captación', 'Individual', 'Interno', 'Otras'];
    const map = new Map();
    for (const a of filteredAudiences) {
      const name = String(a.name || '');
      const idx = name.indexOf(' · ');
      const group = idx > 0 ? name.slice(0, idx) : 'Otras';
      if (!map.has(group)) map.set(group, []);
      map.get(group).push({ ...a, shortName: idx > 0 ? name.slice(idx + 3) : name });
    }
    return [...map.entries()]
      .sort((x, y) => {
        const ix = order.indexOf(x[0]); const iy = order.indexOf(y[0]);
        return (ix === -1 ? 99 : ix) - (iy === -1 ? 99 : iy) || x[0].localeCompare(y[0], 'es');
      })
      .map(([group, items]) => ({
        group,
        items: items.sort((x, y) => String(x.shortName).localeCompare(String(y.shortName), 'es', { numeric: true })),
        contacts: items.reduce((n, a) => n + (Number(a.total_contacts) || 0), 0)
      }));
  }, [filteredAudiences]);
  const isGroupOpen = (g) => (openGroups[g.group] !== undefined ? openGroups[g.group] : (Boolean(audienceEmailSearch) || g.items.length <= 8));
  const isDynamicAudience = (a) => {
    const origin = Array.isArray(a.filters?.originTypes) ? a.filters.originTypes : [];
    return !(origin.length && origin.every((o) => o === 'manual'));
  };
  const defaultLayout = useMemo(() => {
    if (!settings) return null;
    const footerPieces = [];
    if (settings.footer_text) footerPieces.push(settings.footer_text);
    return {
      headerLogo: settings.header_logo || '',
      headerText: settings.header_text || '',
      headerBg: settings.header_bg || '',
      headerTextColor: settings.header_text_color || '#1f2937',
      footerText: footerPieces.join('\n'),
      footerBg: settings.footer_bg || '',
      footerTextColor: settings.footer_text_color || '#4b5563',
      unsubscribeUrl: settings.unsubscribe_url || '',
      socialLinks: settings.social_links || {},
      headerLayout: settings.header_layout || 'logo_left'
    };
  }, [settings]);

  const handleUploadLogo = async (file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      setUploadingLogo(true);
      const res = await apiFetch('/api/uploads/images', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo subir el logo');
      setSettings((p) => ({ ...p, header_logo: data.url }));
    } catch (err) {
      alert(err.message);
    } finally {
      setUploadingLogo(false);
    }
  };
  const renderPreviewBlock = (block) => {
    if (!block) return null;
    const { type, props = {} } = block;
    const resolveSrc = (src) => (src ? toAbsoluteUrl(src) : '');
    if (type === 'heading') {
      return (
        <h3 style={{ textAlign: props.align || 'left', marginBottom: 8 }}>
          {props.text || 'Título'}
        </h3>
      );
    }
    if (type === 'text') {
      const html = sanitizeTextHtml(props.text || '');
      return (
        <div
          style={{
            textAlign: props.align || 'left',
            marginBottom: 8,
            fontFamily: props.fontFamily || 'Arial, sans-serif',
            fontSize: props.fontSize || 14,
            fontWeight: props.fontWeight || '400',
            color: props.color || '#111111',
            lineHeight: props.lineHeight || 1.2
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      );
    }
    if (type === 'image') {
      return (
        <div style={{ textAlign: props.align || 'center', marginBottom: 8 }}>
          {props.src ? (
            <img src={resolveSrc(props.src)} alt={props.alt || ''} style={{ maxWidth: '100%', width: props.width || 600 }} />
          ) : (
            <div style={{ background: '#f8f9fa', height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Imagen</div>
          )}
        </div>
      );
    }
    if (type === 'button') {
      return (
        <div style={{ textAlign: props.align || 'center', marginBottom: 8 }}>
          <button className="btn btn-success btn-sm" type="button">{props.text || 'Botón'}</button>
        </div>
      );
    }
    if (type === 'bullets') {
      const items = (props.items || []).filter((item) => String(item || '').trim());
      if (!items.length) return null;
      const align = props.align || 'left';
      const rowAlign = align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start';
      const textStyle = {
        fontFamily: props.fontFamily || 'Arial, sans-serif',
        fontSize: props.fontSize || 14,
        fontWeight: props.fontWeight || '400',
        color: props.color || '#111111',
        lineHeight: props.lineHeight || 1.2
      };
      return (
        <div style={{ marginBottom: 8, textAlign: align }}>
          {items.map((item, idx) => (
            <div key={`${item}-${idx}`} style={{ marginBottom: 6, textAlign: align }}>
              <span style={{ display: 'inline-flex', alignItems: 'flex-start', gap: 8, justifyContent: rowAlign }}>
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 18,
                    height: 18,
                    borderRadius: '50%',
                    background: props.iconBg || '#16a34a',
                    color: props.iconColor || '#ffffff',
                    fontSize: 11,
                    fontWeight: 700,
                    flexShrink: 0,
                    marginTop: 2
                  }}
                >
                  ✓
                </span>
                <div style={{ ...textStyle, textAlign: align }} dangerouslySetInnerHTML={{ __html: sanitizeTextHtml(item) }} />
              </span>
            </div>
          ))}
        </div>
      );
    }
    if (type === 'spacer') {
      return <div style={{ height: props.height || 16 }} />;
    }
    if (type === 'columns') {
      const cols = props.columns || [];
      return (
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
          {cols.map((col, idx) => (
            <div
              key={idx}
              style={{
                flex: `0 0 ${col.width || 50}%`,
                minWidth: 180
              }}
            >
              {(col.blocks || []).map((inner) => (
                <div key={inner.id} style={{ marginBottom: 8 }}>
                  {renderPreviewBlock(inner)}
                </div>
              ))}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const renderPreviewEmail = (preview) => {
    const headerLayout = previewSettings.header_layout || 'logo_left';
    const logo = previewSettings.header_logo ? <img src={previewSettings.header_logo} alt="Logo" style={{ maxWidth: 140, height: 'auto' }} /> : null;
    const headerText = previewSettings.header_text ? previewSettings.header_text.split('\n').map((l, idx) => <div key={idx}>{l}</div>) : null;
    const social = Object.entries(previewSettings.social_links || {})
      .filter(([, v]) => v)
      .map(([k, v]) => (
        <a key={k} href={v} style={{ textDecoration: 'none', color: previewSettings.footer_text_color || '#555', margin: '0 6px' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, textTransform: 'capitalize' }}>
            {socialIcons[k] || socialIcons.default} {k}
          </span>
        </a>
      ));
    const footerPieces = [];
    if (previewSettings.footer_text) footerPieces.push(previewSettings.footer_text.split('\n').map((l, idx) => <div key={idx}>{l}</div>));
    if (social.length) footerPieces.push(<div key="social" style={{ display: 'flex', justifyContent: 'center', gap: 6, flexWrap: 'wrap' }}>{social}</div>);
    const unsubUrl = preview.unsubscribe_url || previewSettings.unsubscribe_url;
    if (unsubUrl) footerPieces.push(<a key="unsub" href={unsubUrl} style={{ color: previewSettings.footer_text_color || '#555' }}>Darse de baja</a>);

    const header = (logo || headerText) && (
      <div style={{ padding: 12, background: previewSettings.header_bg || '#fff', borderRadius: '6px 6px 0 0' }}>
        {headerLayout === 'stacked_center' ? (
          <div style={{ textAlign: 'center' }}>
            {logo && <div style={{ marginBottom: headerText ? 6 : 0 }}>{logo}</div>}
            {headerText && <div style={{ color: previewSettings.header_text_color || '#1f2937' }}>{headerText}</div>}
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {logo}
            {headerText && <div style={{ color: previewSettings.header_text_color || '#1f2937' }}>{headerText}</div>}
          </div>
        )}
      </div>
    );

    const footer = footerPieces.length ? (
      <div style={{ padding: 12, textAlign: 'center', background: previewSettings.footer_bg || '#f8f9fa', color: previewSettings.footer_text_color || '#555', borderRadius: '0 0 6px 6px', display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'center' }}>
        {footerPieces}
      </div>
    ) : null;

    return (
      <div className="border rounded" style={{ background: '#f8f9fa' }}>
        {header}
        <div style={{ padding: 16, background: '#fff' }}>
          {preview.blocks?.length ? preview.blocks.map((b) => (
            <div key={b.id} className="mb-2">
              {renderPreviewBlock(b)}
            </div>
          )) : (
            <div className="text-muted small text-center">Sin contenido</div>
          )}
        </div>
        {footer}
      </div>
    );
  };

  const filteredCombineAudiences = audiences.filter((a) => {
    const term = combineAudienceSearch.trim().toLowerCase();
    if (!term) return true;
    return (
      (a.name || '').toLowerCase().includes(term)
      || (a.description || '').toLowerCase().includes(term)
      || String(a.id).includes(term)
    );
  });

  return (
    <div className="small" style={{ fontSize: '0.9rem' }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h2 className="mb-0">Email marketing</h2>
          <div className="text-muted small">Campañas, audiencias y plantillas de email.</div>
        </div>
        {activeTab === 'campaigns' && (
            <div className="d-flex gap-2">
            <button
              className="btn btn-outline-secondary"
              onClick={() => setSettingsOpen(true)}
            >
              <BsLayoutTextSidebar className="me-2" />
              Configuración
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={() => {
                setEditorInitial(null);
                setEditingCampaign(null);
                setSelectedAudiences([]);
                const fallbackAcc = defaultAccountId || (emailAccounts[0]?.id ? String(emailAccounts[0].id) : '');
                setDefaultAccountId(fallbackAcc);
                setDefaultProvider('smtp');
                openHtmlImport(null);
              }}
            >
              Importar HTML
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                setEditorInitial(null);
                setEditingCampaign(null);
                setSelectedAudiences([]);
                const fallbackAcc = defaultAccountId || (emailAccounts[0]?.id ? String(emailAccounts[0].id) : '');
                setDefaultAccountId(fallbackAcc);
                setDefaultProvider('smtp');
                setEditorMode('campaign');
                setEditorOpen(true);
              }}
            >
              <BsPlus className="me-2" />
              Crear campaña
            </button>
          </div>
        )}
      </div>

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'campaigns' ? 'active' : ''}`}
            onClick={() => setActiveTab('campaigns')}
          >
            Campañas
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'audiences' ? 'active' : ''}`}
            onClick={() => setActiveTab('audiences')}
          >
            Audiencias
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'templates' ? 'active' : ''}`}
            onClick={() => setActiveTab('templates')}
          >
            Plantillas
          </button>
        </li>
      </ul>

      {activeTab === 'campaigns' && (
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Campañas</h5>
              <span className="text-muted small">Los envíos se procesan automáticamente en segundo plano.</span>
            </div>
            <div className="mb-3 text-muted small">Usa “Enviar…” para enviar ahora o programar.</div>

            <div className="table-responsive">
              <table className="table table-sm align-middle">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Audiencias</th>
                    <th>Stats</th>
                    <th>Estado</th>
                    <th>Creada</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.length ? campaigns.map((c) => (
                    <tr key={c.id}>
                      <td>
                        <div>{c.name}</div>
                        <div className="text-muted small">
                          {c.default_provider === 'elastic'
                            ? 'Motor: Elastic Email'
                            : `Motor: SMTP${c.default_account_id ? ` (cuenta ${c.default_account_id})` : ' (sin cuenta)'}`}
                        </div>
                      </td>
	                      <td>{(c.audience_ids || []).map(audienceNameById).join(', ') || '-'}</td>
	                      <td className="small">
	                        {(() => {
	                          const total = Number(c.jobs_total || 0);
	                          const sent = Number(c.jobs_sent || 0);
	                          const pending = Number(c.jobs_pending || 0);
	                          const err = Number(c.jobs_error || 0);
	                          const pct = total > 0 ? Math.round((sent / total) * 100) : 0;
	                          return (
	                            <div className="d-flex flex-column gap-1" style={{ minWidth: 160 }}>
	                              {total === 0 ? (
	                                <span className="text-muted">Sin encolar</span>
	                              ) : (
	                                <>
	                                  <div className="d-flex justify-content-between">
	                                    <span className="fw-semibold">{sent}/{total}</span>
	                                    <span className="text-muted">{pct}%</span>
	                                  </div>
	                                  <div className="progress" style={{ height: 4 }}>
	                                    <div className="progress-bar bg-success" style={{ width: `${pct}%` }}></div>
	                                    {err > 0 && (
	                                      <div className="progress-bar bg-danger" style={{ width: `${total ? (err / total) * 100 : 0}%` }}></div>
	                                    )}
	                                  </div>
	                                  <div className="text-muted" style={{ fontSize: '0.75rem' }}>
	                                    {pending > 0 && <span>Pend {pending} · </span>}
	                                    {err > 0 && <span className="text-danger">Err {err}</span>}
	                                  </div>
	                                </>
	                              )}
	                              {stats[c.id] ? (
	                                <div className="text-muted" style={{ fontSize: '0.75rem' }}>
	                                  Abiertos {stats[c.id].opened || 0} · Clicks {stats[c.id].clicked || 0}
	                                </div>
	                              ) : total > 0 ? (
	                                <button className="btn btn-sm btn-link p-0 text-start" onClick={() => fetchStats(c.id)}>Ver aperturas/clicks</button>
	                              ) : null}
	                            </div>
	                          );
	                        })()}
	                      </td>
	                      <td>
	                        {(() => {
	                          const ui = getCampaignUiStatus(c);
	                          return (
	                            <>
	                              <span className={`badge bg-${ui.badge} text-uppercase`}>{ui.label}</span>
	                              {c.scheduled_at && (
	                                <div className="text-muted small mt-1">
	                                  {new Date(c.scheduled_at).toLocaleString()}
	                                </div>
	                              )}
	                            </>
	                          );
	                        })()}
	                      </td>
	                      <td>{c.created_at ? new Date(c.created_at).toLocaleString() : '-'}</td>
	                      <td className="text-end">
	                        <div className="d-inline-flex align-items-center gap-2">
                          {c.status === 'enviada' ? (
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => {
                                if (c.content_mode === 'html') {
                                  setEditingCampaign(null);
                                  setHtmlImportSubject(c.subject || '');
                                  setHtmlImportPreheader(c.preheader || '');
                                  setHtmlImportBody(c.html_body || '');
                                  setHtmlImportPreviewMode('desktop');
                                  setSelectedAudiences(c.audience_ids || []);
                                  setDefaultAccountId(c.default_account_id ? String(c.default_account_id) : '');
                                  setDefaultProvider(c.default_provider || 'smtp');
                                  setHtmlImportOpen(true);
                                  return;
                                }
                                setEditingCampaign(null);
                                setEditorInitial({
                                  subject: c.subject || '',
                                  preheader: c.preheader || '',
                                  blocks: c.design_json?.blocks || []
                                });
                                setSelectedAudiences(c.audience_ids || []);
                                setDefaultAccountId(c.default_account_id ? String(c.default_account_id) : '');
                                setDefaultProvider(c.default_provider || 'smtp');
                                setEditorMode('campaign');
                                setEditorOpen(true);
                              }}
                            >
                              Duplicar
                            </button>
                          ) : (
	                            <>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => {
                                  if (c.content_mode === 'html') {
                                    setEditingCampaign(c);
                                    setHtmlImportSubject(c.subject || '');
                                    setHtmlImportPreheader(c.preheader || '');
                                    setHtmlImportBody(c.html_body || '');
                                    setHtmlImportPreviewMode('desktop');
                                    setSelectedAudiences(c.audience_ids || []);
                                    setDefaultAccountId(c.default_account_id ? String(c.default_account_id) : '');
                                    setDefaultProvider(c.default_provider || 'smtp');
                                    setHtmlImportOpen(true);
                                    return;
                                  }
                                  setEditingCampaign(c);
                                  setEditorInitial({
                                    subject: c.subject || '',
                                    preheader: c.preheader || '',
                                    blocks: c.design_json?.blocks || []
                                  });
                                  setSelectedAudiences(c.audience_ids || []);
                                  setDefaultAccountId(c.default_account_id ? String(c.default_account_id) : '');
                                  setDefaultProvider(c.default_provider || 'smtp');
                                  setEditorMode('campaign');
                                  setEditorOpen(true);
                                }}
                              >
                                <BsLayoutTextSidebar className="me-1" />
                                Editar
	                              </button>
	                              <button
	                                className="btn btn-sm btn-primary"
	                                onClick={() => {
	                                  const existingSchedule = toLocalDateTimeInputs(c.scheduled_at);
	                                  const defaults = nextScheduleDefaults();
	                                  setSendStepCampaign(c);
	                                  setSendOptions({
	                                    provider: c.default_provider || defaultProvider || 'smtp',
	                                    accountId: c.default_account_id ? String(c.default_account_id) : defaultAccountId,
	                                    audiences: c.audience_ids || [],
	                                    scheduleDate: existingSchedule?.date || defaults.date,
	                                    scheduleTime: existingSchedule?.time || defaults.time,
	                                    elasticSenderId: c.elastic_sender_id ? String(c.elastic_sender_id) : ''
	                                  });
	                                  setSendStepOpen(true);
	                                }}
	                              >
	                                Enviar…
	                              </button>
	                            </>
	                          )}
	                          <div className="position-relative d-inline-block" onClick={(e) => e.stopPropagation()}>
	                            <button
	                              type="button"
	                              className="btn btn-sm btn-outline-secondary"
	                              onClick={(e) => {
	                                e.stopPropagation();
	                                setCampaignMenuOpenId((prev) => (prev === c.id ? null : c.id));
	                              }}
	                            >
	                              <BsThreeDotsVertical />
	                            </button>
	                            {campaignMenuOpenId === c.id && (
	                              <div
	                                className="dropdown-menu show"
	                                style={{ position: 'absolute', right: 0, top: '100%', zIndex: 2000 }}
	                                onClick={(e) => e.stopPropagation()}
	                              >
                                <button
                                  type="button"
                                  className="dropdown-item"
                                  onClick={() => {
                                    setCampaignMenuOpenId(null);
                                    if (c.content_mode === 'html') {
                                      setHtmlRenderPreviewMode('desktop');
                                      setHtmlRenderPreview({
                                        subject: c.subject || '',
                                        preheader: c.preheader || '',
                                        html: c.html_body || ''
                                      });
                                    } else {
                                      setPreviewData({
                                        subject: c.subject,
                                        preheader: c.preheader,
                                        blocks: c.design_json?.blocks || []
                                      });
                                    }
                                  }}
                                >
                                  Previsualizar
                                </button>
	                                <button
	                                  type="button"
	                                  className="dropdown-item"
	                                  onClick={() => {
	                                    setCampaignMenuOpenId(null);
	                                    openTestModal(c);
	                                  }}
	                                >
	                                  Enviar test
	                                </button>
	                                <button
	                                  type="button"
	                                  className="dropdown-item"
	                                  onClick={async () => {
	                                    setCampaignMenuOpenId(null);
	                                    try {
	                                      const trackingBaseUrl = resolveTrackingBaseUrl();
	                                      const qs = new URLSearchParams({ tracking_base_url: trackingBaseUrl });
	                                      const res = await apiFetch(`/api/email-marketing/campaigns/${c.id}/html?${qs.toString()}`, {
	                                        headers: { Authorization: `Bearer ${token}` }
	                                      });
	                                      const text = await res.text();
	                                      if (res.status === 401) return handleUnauthorized();
	                                      if (!res.ok) throw new Error('Error obteniendo HTML');
	                                      setHtmlPreview(text);
	                                    } catch (err) {
	                                      alert(err.message);
	                                    }
	                                  }}
	                                >
	                                  Ver HTML
	                                </button>
	                                {Number(c.jobs_total || 0) > 0 && (
	                                  <button
	                                    type="button"
	                                    className="dropdown-item"
	                                    onClick={() => {
	                                      setCampaignMenuOpenId(null);
	                                      setJobsCampaignId(c.id);
	                                    }}
	                                  >
	                                    Logs de envíos
	                                  </button>
	                                )}
	                                {Number(c.jobs_error || 0) > 0 && (
	                                  <button
	                                    type="button"
	                                    className="dropdown-item"
	                                    onClick={async () => {
	                                      setCampaignMenuOpenId(null);
	                                      try {
	                                        const res = await apiFetch(`/api/email-marketing/campaigns/${c.id}/retry-errors`, {
	                                          method: 'POST',
	                                          headers: { Authorization: `Bearer ${token}` }
	                                        });
	                                        const data = await parseJsonSafe(res);
	                                        if (res.status === 401) return handleUnauthorized();
	                                        if (!res.ok) throw new Error(data.message || 'Error reintentando');
	                                        alert(`Reintentados ${data.retried}`);
	                                        fetchCampaigns();
	                                        fetchStats(c.id);
	                                      } catch (err) {
	                                        alert(err.message);
	                                      }
	                                    }}
	                                  >
	                                    Reintentar fallidos
	                                  </button>
	                                )}
	                                {c.status === 'programada' && Number(c.jobs_sent || 0) === 0 && (
	                                  <button
	                                    type="button"
	                                    className="dropdown-item text-danger"
	                                    onClick={async () => {
	                                      setCampaignMenuOpenId(null);
	                                      if (!window.confirm('¿Cancelar la programación y volver a borrador?')) return;
	                                      try {
	                                        const res = await apiFetch(`/api/email-marketing/campaigns/${c.id}`, {
	                                          method: 'PUT',
	                                          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	                                          body: JSON.stringify({ status: 'borrador', scheduled_at: null })
	                                        });
	                                        const data = await parseJsonSafe(res);
	                                        if (res.status === 401) return handleUnauthorized();
	                                        if (!res.ok) throw new Error(data.message || 'No se pudo cancelar');
	                                        fetchCampaigns();
	                                      } catch (err) {
	                                        alert(err.message);
	                                      }
	                                    }}
	                                  >
	                                    Cancelar programación
	                                  </button>
	                                )}
	                                {c.status === 'enviada' && (
	                                  <button
	                                    type="button"
	                                    className="dropdown-item"
	                                    onClick={async () => {
	                                      setCampaignMenuOpenId(null);
	                                      try {
	                                        const prev = await apiFetch(`/api/email-marketing/campaigns/${c.id}/resend-unopened/preview`, {
	                                          headers: { Authorization: `Bearer ${token}` }
	                                        });
	                                        const pdata = await parseJsonSafe(prev);
	                                        if (prev.status === 401) return handleUnauthorized();
	                                        if (!prev.ok) throw new Error(pdata.message || 'No se pudo calcular candidatos');
	                                        const candidates = pdata.candidates || 0;
	                                        if (candidates === 0) return alert('No hay destinatarios elegibles. Todos abrieron, clicaron o se dieron de baja.');
	                                        setResendModal({ open: true, campaign: c, candidates, provider: c.default_provider || 'smtp', accountId: c.default_account_id ? String(c.default_account_id) : '', elasticSenderId: c.elastic_sender_id ? String(c.elastic_sender_id) : '', subjectPrefix: '[Reenvío] ' });
	                                      } catch (err) {
	                                        alert(err.message);
	                                      }
	                                    }}
	                                  >
	                                    Reenviar a no abiertos
	                                  </button>
	                                )}
	                              </div>
	                            )}
	                          </div>
	                          <button
	                            className="btn btn-sm btn-outline-danger"
	                            onClick={async () => {
	                              if (!window.confirm('¿Eliminar esta campaña?')) return;
	                              try {
	                                const res = await apiFetch(`/api/email-marketing/campaigns/${c.id}`, {
	                                  method: 'DELETE',
	                                  headers: { Authorization: `Bearer ${token}` }
	                                });
	                                const data = await parseJsonSafe(res);
	                                if (res.status === 401) return handleUnauthorized();
	                                if (!res.ok) throw new Error(data.message || 'No se pudo eliminar');
	                                setCampaigns((prev) => prev.filter((x) => x.id !== c.id));
	                              } catch (err) {
	                                alert(err.message);
	                              }
	                            }}
	                          >
	                            Eliminar
	                          </button>
	                        </div>
	                      </td>
	                    </tr>
	                  )) : (
	                    <tr><td colSpan="6" className="text-muted small">Sin campañas.</td></tr>
	                  )}
	                </tbody>
	              </table>
	            </div>
	            <div className="text-muted small mt-2">
	              <span className="me-3"><span className="badge bg-secondary me-1">BORRADOR</span>no se envía</span>
	              <span className="me-3"><span className="badge bg-info text-uppercase me-1">PROGRAMADA</span>se enviará en la fecha</span>
	              <span className="me-3"><span className="badge bg-primary text-uppercase me-1">ENVIÁNDOSE</span>procesando envíos</span>
	              <span><span className="badge bg-success text-uppercase me-1">ENVIADA</span>finalizada</span>
	            </div>
	          </div>
	        </div>
	      )}

      {editorOpen && (
        <EmailEditor
          initialValue={editorInitial}
          onClose={() => {
            setEditorOpen(false);
            setEditingCampaign(null);
            setEditorMode('campaign');
          }}
          onSave={(val) => {
            if (editorMode === 'template') saveTemplate(val);
            else saveCampaign(val);
          }}
          defaultLayout={defaultLayout}
        />
      )}
      {htmlImportOpen && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editingCampaign?.id ? 'Editar campaña HTML' : 'Importar HTML'}</h5>
                <button className="btn-close" onClick={closeHtmlImport}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-lg-6">
                    <div className="row g-2 mb-2">
                      <div className="col-md-6">
                        <label className="form-label small">Asunto</label>
                        <input
                          className="form-control form-control-sm"
                          value={htmlImportSubject}
                          onChange={(e) => setHtmlImportSubject(e.target.value)}
                          placeholder="Asunto del email"
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label small">Preheader</label>
                        <input
                          className="form-control form-control-sm"
                          value={htmlImportPreheader}
                          onChange={(e) => setHtmlImportPreheader(e.target.value)}
                          placeholder="Texto preheader"
                        />
                      </div>
                    </div>
                    <div className="mb-2 text-muted small">Pega un HTML completo (incluye &lt;html&gt; y &lt;body&gt;).</div>
                    <textarea
                      className="form-control font-monospace"
                      rows="14"
                      value={htmlImportBody}
                      onChange={(e) => setHtmlImportBody(e.target.value)}
                      placeholder="<!DOCTYPE html>..."
                    />
                    {htmlImportBody.trim() && missingHtmlPlaceholders.length > 0 && (
                      <div className="alert alert-warning py-2 mt-3 mb-0">
                        <div className="fw-semibold">Faltan placeholders:</div>
                        <div className="small">
                          {missingHtmlPlaceholders.map((p) => p.token).join(' · ')}
                        </div>
                        <button
                          className="btn btn-sm btn-outline-dark mt-2"
                          onClick={() => {
                            const missingKeys = missingHtmlPlaceholders.map((p) => p.key);
                            setHtmlImportBody((prev) => injectHtmlPlaceholders(prev, missingKeys));
                          }}
                        >
                          Inyectar placeholders faltantes
                        </button>
                      </div>
                    )}
                    {htmlImportBody.trim() && (htmlImportAnalysis.errors.length > 0 || htmlImportAnalysis.warnings.length > 0) && (
                      <div className={`alert ${htmlImportAnalysis.errors.length ? 'alert-danger' : 'alert-info'} py-2 mt-3 mb-0`}>
                        <div className="fw-semibold">Revisión de HTML</div>
                        {htmlImportAnalysis.errors.length > 0 && (
                          <div className="small mt-1">
                            <div className="fw-semibold">Errores:</div>
                            <ul className="mb-0">
                              {htmlImportAnalysis.errors.map((item, idx) => (
                                <li key={`html-error-${idx}`}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                        {htmlImportAnalysis.warnings.length > 0 && (
                          <div className={`small ${htmlImportAnalysis.errors.length ? 'mt-2' : 'mt-1'}`}>
                            <div className="fw-semibold">Avisos:</div>
                            <ul className="mb-0">
                              {htmlImportAnalysis.warnings.map((item, idx) => (
                                <li key={`html-warning-${idx}`}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="fw-semibold">Previsualización</div>
                      <div className="btn-group btn-group-sm">
                        <button
                          className={`btn ${htmlImportPreviewMode === 'desktop' ? 'btn-primary' : 'btn-outline-secondary'}`}
                          onClick={() => setHtmlImportPreviewMode('desktop')}
                        >
                          Desktop
                        </button>
                        <button
                          className={`btn ${htmlImportPreviewMode === 'mobile' ? 'btn-primary' : 'btn-outline-secondary'}`}
                          onClick={() => setHtmlImportPreviewMode('mobile')}
                        >
                          Móvil
                        </button>
                      </div>
                    </div>
                    {renderHtmlFrame(
                      buildHtmlPreview(htmlImportBody, {
                        preheader: htmlImportPreheader || 'Preheader de ejemplo',
                        unsubscribeUrl: previewSettings.unsubscribe_url || '#',
                        name: 'Cliente',
                        email: 'cliente@ejemplo.com'
                      }),
                      htmlImportPreviewMode
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={closeHtmlImport}>Cerrar</button>
                <button className="btn btn-primary" onClick={saveHtmlCampaign}>Guardar campaña</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {testModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Enviar test · {testModal.campaign?.name || 'Campaña'}</h5>
                <button className="btn-close" onClick={() => setTestModal((p) => ({ ...p, open: false }))}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning py-2 small mb-3">
                  Envío de prueba a una única dirección. <strong>No aparece en las estadísticas</strong> y no afecta al estado de la campaña.
                </div>
                <div className="mb-3">
                  <label className="form-label small">Email destino</label>
                  <input
                    className="form-control"
                    value={testModal.email}
                    onChange={(e) => setTestModal((p) => ({ ...p, email: e.target.value }))}
                    placeholder="persona@dominio.com"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label small">Motor de envío</label>
                  <select
                    className="form-select"
                    value={testModal.provider}
                    onChange={(e) => setTestModal((p) => ({ ...p, provider: e.target.value }))}
                  >
                    <option value="smtp">SMTP</option>
                    <option value="elastic">Elastic Email</option>
                  </select>
                </div>
                {testModal.provider === 'smtp' && (
                  <div className="mb-3">
                    <label className="form-label small">Cuenta SMTP</label>
                    <select
                      className="form-select"
                      value={testModal.accountId}
                      onChange={(e) => setTestModal((p) => ({ ...p, accountId: e.target.value }))}
                    >
                      <option value="">Selecciona cuenta</option>
                      {emailAccounts.map((acc) => (
                        <option key={acc.id} value={acc.id}>
                          {acc.from_name || acc.from_email} (id {acc.id})
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {testModal.provider === 'elastic' && (
                  <div className="mb-3">
                    <label className="form-label small">Remitente (dominio Elastic)</label>
                    <select
                      className="form-select"
                      value={testModal.elasticSenderId}
                      onChange={(e) => setTestModal((p) => ({ ...p, elasticSenderId: e.target.value }))}
                    >
                      <option value="">{elasticSenders.length ? 'Usar remitente por defecto de la cuenta' : 'Aún no hay remitentes configurados'}</option>
                      {elasticSenders.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name} — {s.from_email}{s.is_default ? ' (por defecto)' : ''}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setTestModal((p) => ({ ...p, open: false }))}>Cerrar</button>
                <button className="btn btn-primary" onClick={handleSendTest}>Enviar test</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {previewData && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Previsualización</h5>
                <button className="btn-close" onClick={() => setPreviewData(null)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <div className="fw-bold">Asunto:</div>
                  <div>{previewData.subject || '-'}</div>
                </div>
                <div className="mb-3">
                  <div className="fw-bold">Preheader:</div>
                  <div>{previewData.preheader || '-'}</div>
                </div>
                {renderPreviewEmail(previewData)}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setPreviewData(null)}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {htmlRenderPreview && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Previsualización HTML</h5>
                <button className="btn-close" onClick={() => setHtmlRenderPreview(null)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <div className="fw-bold">Asunto:</div>
                  <div>{htmlRenderPreview.subject || '-'}</div>
                </div>
                <div className="mb-3">
                  <div className="fw-bold">Preheader:</div>
                  <div>{htmlRenderPreview.preheader || '-'}</div>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="fw-semibold">Vista</div>
                  <div className="btn-group btn-group-sm">
                    <button
                      className={`btn ${htmlRenderPreviewMode === 'desktop' ? 'btn-primary' : 'btn-outline-secondary'}`}
                      onClick={() => setHtmlRenderPreviewMode('desktop')}
                    >
                      Desktop
                    </button>
                    <button
                      className={`btn ${htmlRenderPreviewMode === 'mobile' ? 'btn-primary' : 'btn-outline-secondary'}`}
                      onClick={() => setHtmlRenderPreviewMode('mobile')}
                    >
                      Móvil
                    </button>
                  </div>
                </div>
                {renderHtmlFrame(
                  buildHtmlPreview(htmlRenderPreview.html || '', {
                    preheader: htmlRenderPreview.preheader || 'Preheader de ejemplo',
                    unsubscribeUrl: previewSettings.unsubscribe_url || '#',
                    name: 'Cliente',
                    email: 'cliente@ejemplo.com'
                  }),
                  htmlRenderPreviewMode
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setHtmlRenderPreview(null)}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {settingsOpen && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Configuración de Email Marketing</h5>
                <button className="btn-close" onClick={() => setSettingsOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-lg-7">
                    <ul className="nav nav-tabs mb-3">
                      <li className="nav-item">
                        <button type="button" className={`nav-link ${settingsTab === 'branding' ? 'active' : ''}`} onClick={() => setSettingsTab('branding')}>
                          Branding
                        </button>
                      </li>
                      <li className="nav-item">
                        <button type="button" className={`nav-link ${settingsTab === 'envio' ? 'active' : ''}`} onClick={() => setSettingsTab('envio')}>
                          Envío y tracking
                        </button>
                      </li>
                      <li className="nav-item">
                        <button type="button" className={`nav-link ${settingsTab === 'social' ? 'active' : ''}`} onClick={() => setSettingsTab('social')}>
                          Redes sociales
                        </button>
                      </li>
                    </ul>
                    {settingsTab === 'branding' && (
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label small d-flex justify-content-between align-items-center">
                          <span>Logo</span>
                          {uploadingLogo && <span className="text-muted small">Subiendo...</span>}
                        </label>
                        <div className="d-flex gap-2">
                          <input
                            className="form-control form-control-sm"
                            placeholder="URL del logo"
                            value={settings.header_logo || ''}
                            onChange={(e) => setSettings((p) => ({ ...p, header_logo: e.target.value }))}
                          />
                          <label className="btn btn-outline-secondary btn-sm mb-0">
                            Subir
                            <input
                              type="file"
                              accept="image/*"
                              hidden
                              onChange={(e) => handleUploadLogo(e.target.files?.[0])}
                              disabled={uploadingLogo}
                            />
                          </label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Header fondo</label>
                        <input
                          type="color"
                          className="form-control form-control-sm"
                          value={settings.header_bg || '#ffffff'}
                          onChange={(e) => setSettings((p) => ({ ...p, header_bg: e.target.value }))}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Header texto color</label>
                        <input
                          type="color"
                          className="form-control form-control-sm"
                          value={settings.header_text_color || '#1f2937'}
                          onChange={(e) => setSettings((p) => ({ ...p, header_text_color: e.target.value }))}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Footer fondo</label>
                        <input
                          type="color"
                          className="form-control form-control-sm"
                          value={settings.footer_bg || '#ffffff'}
                          onChange={(e) => setSettings((p) => ({ ...p, footer_bg: e.target.value }))}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small">Footer texto color</label>
                        <input
                          type="color"
                          className="form-control form-control-sm"
                          value={settings.footer_text_color || '#4b5563'}
                          onChange={(e) => setSettings((p) => ({ ...p, footer_text_color: e.target.value }))}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label small">Layout header</label>
                        <select
                          className="form-select form-select-sm"
                          value={settings.header_layout || 'logo_left'}
                          onChange={(e) => setSettings((p) => ({ ...p, header_layout: e.target.value }))}
                        >
                          <option value="logo_left">Logo izquierda / texto derecha</option>
                          <option value="stacked_center">Logo centrado con texto debajo</option>
                        </select>
                      </div>
                      <div className="col-12">
                        <label className="form-label small">Texto header</label>
                        <textarea
                          className="form-control form-control-sm"
                          rows="2"
                          value={settings.header_text || ''}
                          onChange={(e) => setSettings((p) => ({ ...p, header_text: e.target.value }))}
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label small">Texto footer / legal</label>
                        <textarea
                          className="form-control form-control-sm"
                          rows="3"
                          value={settings.footer_text || ''}
                          onChange={(e) => setSettings((p) => ({ ...p, footer_text: e.target.value }))}
                        />
                      </div>
                    </div>
                    )}
                    {settingsTab === 'envio' && (
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label small">Unsubscribe URL (fallback)</label>
                        <input
                          className="form-control form-control-sm"
                          value={settings.unsubscribe_url || ''}
                          onChange={(e) => setSettings((p) => ({ ...p, unsubscribe_url: e.target.value }))}
                          placeholder="Ej: https://tudominio.com/api/email-marketing/unsubscribe"
                        />
                        <div className="form-text">Solo se usa si no se puede construir automáticamente la URL de tracking. Normalmente déjalo vacío.</div>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label small">Elastic Email API Key</label>
                        <input
                          className="form-control form-control-sm"
                          value={settings.elastic_api_key || ''}
                          onChange={(e) => setSettings((p) => ({ ...p, elastic_api_key: e.target.value }))}
                          placeholder="Copiala desde Elastic Email"
                        />
                        <div className="form-text">Se usa si eliges el método “Elastic Email API”.</div>
                      </div>
                    <div className="col-12">
                      <div className="d-flex justify-content-between align-items-center p-3 border rounded bg-light">
                        <div>
                          <div className="fw-semibold">Remitentes (dominios verificados en Elastic)</div>
                          <div className="text-muted small">
                            Gestionas aquí los remitentes (email, nombre, reply-to). Puedes tener varios dominios bajo la misma API key y elegir uno al enviar cada campaña. Marca uno como "por defecto" para usarlo si la campaña no especifica otro.
                          </div>
                        </div>
                        <button type="button" className="btn btn-sm btn-primary" onClick={() => { setSenderForm({ id: null, name: '', from_email: '', from_name: '', reply_to: '', is_default: false }); setSendersPanelOpen(true); }}>
                          Gestionar remitentes ({elasticSenders.length})
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small">Buzón de rebotes SMTP</label>
                      <input
                        className="form-control form-control-sm"
                        value={settings.bounce_email || ''}
                        onChange={(e) => setSettings((p) => ({ ...p, bounce_email: e.target.value }))}
                        placeholder="bounce@inter-conecta.com"
                      />
                      <div className="form-text">Solo se usa en envíos SMTP como Return-Path.</div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small">Intervalo sync estados (min)</label>
                      <input
                        type="number"
                        min="30"
                        step="1"
                        className="form-control form-control-sm"
                        value={settings.elastic_suppression_poll_interval_minutes ?? ''}
                        onChange={(e) => setSettings((p) => ({ ...p, elastic_suppression_poll_interval_minutes: e.target.value }))}
                        placeholder="360"
                      />
                      <div className="form-text">Aplica a rebotes, bajas y abuso. Mínimo 30 min.</div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small">Intervalo sync aperturas/clics (min)</label>
                      <input
                        type="number"
                        min="30"
                        step="1"
                        className="form-control form-control-sm"
                        value={settings.elastic_events_poll_interval_minutes ?? ''}
                        onChange={(e) => setSettings((p) => ({ ...p, elastic_events_poll_interval_minutes: e.target.value }))}
                        placeholder="120"
                      />
                      <div className="form-text">Sincroniza eventos Open/Click con Elastic Email.</div>
                    </div>
                    </div>
                    )}
                    {settingsTab === 'social' && (
                    <div className="row g-3">
                      <div className="col-md-6">
                        {['facebook', 'instagram', 'linkedin', 'twitter'].map((key) => (
                          <div className="mb-2" key={key}>
                            <input
                              className="form-control form-control-sm"
                              placeholder={`${key} URL`}
                              value={(settings.social_links || {})[key] || ''}
                              onChange={(e) =>
                                setSettings((p) => ({
                                  ...p,
                                  social_links: { ...(p.social_links || {}), [key]: e.target.value }
                                }))
                              }
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                    )}
                  </div>
                  <div className="col-lg-5">
                    <div className="position-sticky" style={{ top: 10 }}>
	                      <h6 className="mb-2">Previsualización</h6>
                      {renderSettingsPreview()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setSettingsOpen(false)}>Cerrar</button>
                <button className="btn btn-primary" onClick={saveSettings}>Guardar</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {jobsCampaignId && (
        <EmailMarketingJobsModal
          campaignId={jobsCampaignId}
          onClose={() => setJobsCampaignId(null)}
        />
      )}
{htmlPreview && (
  <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.6)' }}>
    <div className="modal-dialog modal-xl modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header">
                <h5 className="modal-title">HTML renderizado</h5>
                <button className="btn-close" onClick={() => setHtmlPreview(null)}></button>
              </div>
              <div className="modal-body">
                <pre style={{ whiteSpace: 'pre-wrap', background: '#111', color: '#0f0', padding: 12, borderRadius: 6, fontSize: 12 }}>
                  {htmlPreview}
                </pre>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setHtmlPreview(null)}>Cerrar</button>
              </div>
            </div>
          </div>
  </div>
)}

{createAudienceModal && (
  <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-lg modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Crear audiencia</h5>
          <button className="btn-close" onClick={() => setCreateAudienceModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="btn-group w-100 mb-3" role="group">
            <button
              type="button"
              className={`btn ${!manualMode ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setManualMode(false)}
            >
              Filtro dinámico
            </button>
            <button
              type="button"
              className={`btn ${manualMode ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setManualMode(true)}
            >
              Lista manual / importada
            </button>
          </div>
          <div className="text-muted small mb-3">
            {manualMode
              ? 'Crearás una lista de contactos fija (añadiéndolos a mano o importando Excel/CSV). Útil para envíos puntuales.'
              : 'La audiencia se recalculará dinámicamente con el filtro. Al enviar, se cogen los contactos que cumplan el criterio en ese momento.'}
            {' '}Para combinar varias audiencias existentes usa el botón "Crear audiencia combinada" de la lista.
          </div>
          {!manualMode && (
            <>
              <div className="row g-2 mb-3">
                <div className="col-md-6">
                  <label className="form-label small">Tipo de contacto</label>
                  <select
                    className="form-select form-select-sm"
                    value={audienceFilters.originTypes[0] || ''}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (!val) setAudienceFilters((p) => ({ ...p, originTypes: [], clienteTipo: [], clienteEstado: [], businessSector: '', businessStatus: '' }));
                      else if (val === 'cliente') setAudienceFilters((p) => ({ ...p, originTypes: ['cliente'], clienteTipo: ['Cliente'], clienteEstado: [] }));
                      else if (val === 'lead') setAudienceFilters((p) => ({ ...p, originTypes: ['cliente'], clienteTipo: ['Lead'], clienteEstado: [] }));
                      else if (val === 'business') setAudienceFilters((p) => ({ ...p, originTypes: ['business'], businessSector: '', businessStatus: '' }));
                    }}
                  >
                    <option value="">Todos</option>
                    <option value="cliente">Clientes</option>
                    <option value="lead">Leads</option>
                    <option value="business">Captación business</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small">Sector</label>
                  <select
                    className="form-select form-select-sm"
                    value={audienceFilters.businessSector}
                    onChange={(e) => setAudienceFilters((p) => ({ ...p, businessSector: e.target.value }))}
                    disabled={!(audienceFilters.originTypes.includes('business'))}
                  >
                    <option value="">Todos los sectores</option>
                    {businessSectors.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              <div className="row g-2 mb-3">
                <div className="col-md-6">
                  <label className="form-label small">Ciudad</label>
                  <input
                    className="form-control form-control-sm"
                    placeholder="Ej. Madrid, Sevilla..."
                    value={audienceFilters.search}
                    onChange={(e) => setAudienceFilters((p) => ({ ...p, search: e.target.value }))}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small">Estado cliente</label>
                  <select
                    className="form-select form-select-sm"
                    value={audienceFilters.clienteEstado[0] || ''}
                    disabled={!audienceFilters.originTypes.includes('cliente')}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (!val) setAudienceFilters((p) => ({ ...p, clienteEstado: [] }));
                      else setAudienceFilters((p) => ({ ...p, clienteEstado: [val] }));
                    }}
                  >
                    <option value="">Todos</option>
                    <option value="Activo">Activos</option>
                    <option value="Inactivo">Inactivos</option>
                  </select>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="text-muted small">Previsualizar contactos (máx 200)</div>
                <button className="btn btn-sm btn-outline-secondary" onClick={fetchContacts}>Aplicar filtros</button>
              </div>
              <div className="table-responsive mb-3" style={{ maxHeight: 200 }}>
                <table className="table table-sm align-middle">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Email</th>
                      <th>Tipo</th>
                      <th>Ciudad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contactsPreview.items?.length ? contactsPreview.items.map((c) => (
                      <tr key={`${c.tipo}-${c.id}`}>
                        <td>{c.nombre || '-'}</td>
                        <td>{c.email}</td>
                        <td>{c.tipo}</td>
                        <td>{c.ciudad || '-'}</td>
                      </tr>
                    )) : (
                      <tr><td colSpan="4" className="text-muted small">Sin resultados</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div className="row g-2">
            <div className="col-md-6">
              <label className="form-label small">Nombre</label>
              <input
                className="form-control form-control-sm"
                placeholder="Nombre de audiencia"
                value={audienceName}
                onChange={(e) => setAudienceName(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label small">Descripción</label>
              <input
                className="form-control form-control-sm"
                placeholder="Opcional"
                value={audienceDesc}
                onChange={(e) => setAudienceDesc(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline-secondary" onClick={() => setCreateAudienceModal(false)}>Cancelar</button>
          <button className="btn btn-primary" onClick={() => { saveAudience(); setCreateAudienceModal(false); }}>
            Guardar audiencia
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{combineAudienceModal && (
  <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-lg modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Crear audiencia combinada</h5>
          <button className="btn-close" onClick={() => setCombineAudienceModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="alert alert-light small mb-3">
            Selecciona varias audiencias y se unificarán en una sola (sin duplicados por email).
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="fw-semibold">
              Total combinado estimado:{' '}
              {combineAudienceEstimate.loading ? 'Calculando...' : combineAudienceEstimate.total}
            </div>
            <div className="d-flex gap-2 align-items-center" style={{ maxWidth: 320 }}>
              <input
                className="form-control form-control-sm"
                placeholder="Buscar audiencia..."
                value={combineAudienceSearch}
                onChange={(e) => setCombineAudienceSearch(e.target.value)}
              />
              {combineAudienceSearch && (
                <button className="btn btn-outline-secondary btn-sm" onClick={() => setCombineAudienceSearch('')}>
                  Limpiar
                </button>
              )}
            </div>
          </div>
          <div className="row g-2 mb-3">
            <div className="col-md-6">
              <label className="form-label small">Nombre</label>
              <input
                className="form-control form-control-sm"
                placeholder="Nombre de audiencia combinada"
                value={combineAudienceName}
                onChange={(e) => setCombineAudienceName(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label small">Descripción</label>
              <input
                className="form-control form-control-sm"
                placeholder="Opcional"
                value={combineAudienceDesc}
                onChange={(e) => setCombineAudienceDesc(e.target.value)}
              />
            </div>
          </div>
          <div className="table-responsive" style={{ maxHeight: 260 }}>
            <table className="table table-sm align-middle">
              <thead>
                <tr>
                  <th></th>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Contactos</th>
                </tr>
              </thead>
              <tbody>
                {filteredCombineAudiences.length ? filteredCombineAudiences.map((a) => (
                  <tr key={a.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={combineAudienceIds.includes(a.id)}
                        onChange={(e) => {
                          setCombineAudienceIds((prev) =>
                            e.target.checked ? [...prev, a.id] : prev.filter((id) => id !== a.id)
                          );
                        }}
                      />
                    </td>
                    <td>{a.name}</td>
                    <td className="text-muted small">{a.description || '-'}</td>
                    <td>{a.total_contacts ?? 0}</td>
                  </tr>
                )) : (
                  <tr><td colSpan="4" className="text-muted small">No hay audiencias guardadas.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline-secondary" onClick={() => setCombineAudienceModal(false)}>Cancelar</button>
          <button className="btn btn-primary" onClick={saveCombinedAudience} disabled={combineAudienceSaving}>
            {combineAudienceSaving ? 'Creando...' : 'Crear audiencia'}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{manualContactModal && (
  <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-lg modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Añadir contacto manual</h5>
          <button className="btn-close" onClick={() => setManualContactModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="row g-2 align-items-end mb-3">
            <div className="col-md-4">
              <label className="form-label small">Audiencia</label>
              <select
                className="form-select form-select-sm"
                value={manualAudienceId}
                onChange={(e) => setManualAudienceId(e.target.value)}
              >
                <option value="">Selecciona</option>
                {audiences.map((a) => (
                  <option key={a.id} value={a.id}>{a.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label small">Nombre</label>
              <input
                className="form-control form-control-sm"
                value={manualContactForm.name}
                onChange={(e) => setManualContactForm((p) => ({ ...p, name: e.target.value }))}
                placeholder="Opcional"
              />
            </div>
            <div className="col-md-3">
              <label className="form-label small">Email</label>
              <input
                className="form-control form-control-sm"
                value={manualContactForm.email}
                onChange={(e) => setManualContactForm((p) => ({ ...p, email: e.target.value }))}
                placeholder="email@ejemplo.com"
              />
            </div>
            <div className="col-md-2">
              <label className="form-label small">Teléfono</label>
              <input
                className="form-control form-control-sm"
                value={manualContactForm.phone}
                onChange={(e) => setManualContactForm((p) => ({ ...p, phone: e.target.value }))}
                placeholder="+34..."
              />
            </div>
          </div>
          <div className="d-flex justify-content-end mb-3">
            <button className="btn btn-sm btn-outline-primary" onClick={addManualContact} disabled={!manualAudienceId}>
              Añadir
            </button>
          </div>
          <div className="table-responsive" style={{ maxHeight: 250 }}>
            <table className="table table-sm align-middle">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>Teléfono</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {manualContacts.items?.length ? manualContacts.items.map((c) => (
                  <tr key={c.id}>
                    <td>{c.nombre || '-'}</td>
                    <td>{c.email}</td>
                    <td>{c.phone || '-'}</td>
                    <td className="text-end">
                      <button className="btn btn-sm btn-outline-danger" onClick={() => deleteManualContact(c.id)}>Eliminar</button>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan="4" className="text-muted small">No hay contactos manuales.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline-secondary" onClick={() => setManualContactModal(false)}>Cerrar</button>
        </div>
      </div>
    </div>
  </div>
)}
      {activeTab === 'audiences' && (
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 className="mb-0">Audiencias</h5>
              <div className="text-muted small">Segmenta clientes, leads y captación business.</div>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-primary btn-sm" onClick={() => setCreateAudienceModal(true)}>
                Crear audiencia
              </button>
              <button className="btn btn-outline-primary btn-sm" onClick={() => setCombineAudienceModal(true)}>
                Crear audiencia combinada
              </button>
              <button className="btn btn-outline-secondary btn-sm" onClick={() => setManualContactModal(true)}>
                Contacto manual
              </button>
            </div>
          </div>
          <div className="text-muted small mb-3">Crea audiencias con el botón y gestiona las existentes debajo.</div>
          <div className="mt-4">
            <div className="mb-3">
              <label className="form-label small">Buscar por email o dominio</label>
              <div className="d-flex gap-2">
                <input
                  className="form-control form-control-sm"
                  placeholder="info@midominio.com o midominio.com"
                  value={audienceEmailSearch}
                  onChange={(e) => setAudienceEmailSearch(e.target.value)}
                />
                {audienceEmailSearch && (
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={clearAudienceSearch}
                  >
                    Limpiar
                  </button>
                )}
              </div>
              {audienceEmailLoading && <div className="text-muted small mt-1">Buscando audiencias...</div>}
              {!audienceEmailLoading && audienceEmailError && (
                <div className="text-danger small mt-1">{audienceEmailError}</div>
              )}
              {!audienceEmailLoading && audienceEmailMatches && (
                <div className="text-muted small mt-1">{audienceEmailMatches.length} audiencias encontradas</div>
              )}
            </div>
            <div className="table-responsive">
              <table className="table table-sm align-middle">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th className="text-end">Contactos</th>
                    <th>Campañas</th>
                    <th>Creada</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAudiences.length ? audienceGroups.map((g) => [
                    <tr key={`g-${g.group}`} className="table-light" style={{ cursor: 'pointer' }} onClick={() => setOpenGroups((p) => ({ ...p, [g.group]: !isGroupOpen(g) }))}>
                      <td colSpan="2" className="fw-semibold">
                        <span className="me-2">{isGroupOpen(g) ? '▾' : '▸'}</span>{g.group}
                        <span className="text-muted fw-normal ms-2">{g.items.length} audiencia{g.items.length === 1 ? '' : 's'}</span>
                      </td>
                      <td className="text-end text-muted">{g.contacts.toLocaleString('es-ES')}</td>
                      <td colSpan="3"></td>
                    </tr>,
                    ...(isGroupOpen(g) ? g.items.map((a) => (
                    <tr key={a.id}>
                      <td>
                        <Link to={`/email-marketing/audiencias/${a.id}`} state={{ audience: a }}>
                          {a.shortName}
                        </Link>
                        {isDynamicAudience(a) && <span className="badge bg-info text-dark ms-2" title="Se calcula al momento con los filtros guardados (clientes, leads o negocios captados)">Dinámica</span>}
                      </td>
                      <td className="small text-muted" style={{ maxWidth: 420 }}>{a.description || '-'}</td>
                      <td className="text-end" title={isDynamicAudience(a) ? `${a.manual_contacts || 0} añadidos a mano` : ''}>{a.total_contacts ?? '–'}</td>
                      <td className="small text-muted">
                        {a.campaigns_count > 0
                          ? `${a.campaigns_count} · última ${new Date(a.last_campaign_at).toLocaleDateString('es-ES')}`
                          : <span className="text-warning">Sin usar</span>}
                      </td>
                      <td className="small text-muted">{new Date(a.created_at).toLocaleDateString('es-ES')}</td>
                      <td className="text-end">
                        <div className="btn-group btn-group-sm">
                          <button
                            className="btn btn-outline-danger"
                            onClick={async () => {
                              if (!window.confirm(`¿Eliminar la audiencia "${a.name}"?`)) return;
                              try {
                                const res = await apiFetch(`/api/email-marketing/audiences/${a.id}`, {
                                  method: 'DELETE',
                                  headers: { Authorization: `Bearer ${token}` }
                                });
                                if (res.status === 401) return handleUnauthorized();
                                if (!res.ok) {
                                  const data = await parseJsonSafe(res);
                                  throw new Error(data.message || 'No se pudo eliminar');
                                }
                                fetchAudiences();
                              } catch (err) {
                                alert(err.message);
                              }
                            }}
                          >
                            Eliminar
                          </button>
                        </div>
                      </td>
                    </tr>
                    )) : [])
                  ]) : (
                    <tr>
                      <td colSpan="6" className="text-muted small">
                        {audienceEmailSearch ? 'No hay audiencias para ese email.' : 'No hay audiencias guardadas.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      )}

      {activeTab === 'templates' && (
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 className="mb-0">Plantillas</h5>
                <div className="text-muted small">Diseños reutilizables para tus emails.</div>
              </div>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => {
                  setEditorInitial(null);
                  setEditorMode('template');
                  setEditorOpen(true);
                }}
              >
                <BsPlus className="me-1" />
                Nueva plantilla
              </button>
            </div>
            <div className="table-responsive">
              <table className="table table-sm align-middle">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Asunto</th>
                    <th>Creada</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {templates.length ? templates.map((t) => (
                    <tr key={t.id}>
                      <td>{t.name}</td>
                      <td>{t.subject || '-'}</td>
                      <td>{t.created_at ? new Date(t.created_at).toLocaleString() : '-'}</td>
                      <td className="text-end">
                        <div className="btn-group btn-group-sm">
                          <button
                            className="btn btn-outline-primary"
                            onClick={() => {
                              setEditorInitial({
                                subject: t.subject || '',
                                preheader: t.preheader || '',
                                blocks: t.design_json?.blocks || []
                              });
                              setEditorMode('campaign');
                              setEditorOpen(true);
                            }}
                          >
                            Usar en campaña
                          </button>
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              setEditorInitial({
                                subject: t.subject || '',
                                preheader: t.preheader || '',
                                blocks: t.design_json?.blocks || []
                              });
                              setEditorMode('template');
                              setEditorOpen(true);
                            }}
                          >
                            Editar
                          </button>
                          <button
                            className="btn btn-outline-danger"
                            onClick={async () => {
                              if (!window.confirm('¿Eliminar plantilla?')) return;
                              try {
                                const res = await apiFetch(`/api/email-marketing/templates/${t.id}`, {
                                  method: 'DELETE',
                                  headers: { Authorization: `Bearer ${token}` }
                                });
                                if (res.status === 401) return handleUnauthorized();
                                if (!res.ok) throw new Error('No se pudo eliminar');
                                fetchTemplates();
                              } catch (err) {
                                alert(err.message);
                              }
                            }}
                          >
                            Eliminar
                          </button>
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan="4" className="text-muted small">No hay plantillas.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {sendStepOpen && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Enviar campaña</h5>
                <button className="btn-close" onClick={() => setSendStepOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <div className="text-muted small">Campaña</div>
                  <div className="fw-semibold">{sendStepCampaign?.name || '—'}</div>
                </div>
                <div className="row g-3 mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Motor de envío</label>
                    <select
                      className="form-select"
                      value={sendOptions.provider}
                      onChange={(e) => setSendOptions((prev) => ({ ...prev, provider: e.target.value }))}
                    >
                      <option value="smtp">SMTP (cuenta propia)</option>
                      <option value="elastic">Elastic Email API</option>
                    </select>
                  </div>
                  {sendOptions.provider === 'smtp' && (
                    <div className="col-md-6">
                      <label className="form-label">Cuenta SMTP</label>
                      <select
                        className="form-select"
                        value={sendOptions.accountId}
                        onChange={(e) => setSendOptions((prev) => ({ ...prev, accountId: e.target.value }))}
                      >
                        <option value="">Selecciona cuenta</option>
                        {emailAccounts.map((acc) => (
                          <option key={acc.id} value={acc.id}>{acc.from_name || acc.from_email} (id {acc.id})</option>
                        ))}
                      </select>
                      <div className="form-text">Requerido para SMTP.</div>
                    </div>
                  )}
	                </div>
	                {sendOptions.provider === 'elastic' && (
	                  <div className="mb-3">
	                    <label className="form-label">Remitente (dominio Elastic)</label>
	                    <select
	                      className="form-select"
	                      value={sendOptions.elasticSenderId || ''}
	                      onChange={(e) => setSendOptions((prev) => ({ ...prev, elasticSenderId: e.target.value }))}
	                    >
	                      <option value="">{elasticSenders.length ? 'Usar remitente por defecto de la cuenta' : 'Aún no hay remitentes configurados'}</option>
	                      {elasticSenders.map((s) => (
	                        <option key={s.id} value={s.id}>
	                          {s.name} — {s.from_email}{s.is_default ? ' (por defecto)' : ''}
	                        </option>
	                      ))}
	                    </select>
	                    <div className="form-text">Debe estar verificado en tu cuenta Elastic.</div>
	                  </div>
	                )}
	                <div className="mb-3">
	                  <div className="d-flex justify-content-between align-items-center">
	                    <label className="form-label mb-0">Audiencias</label>
	                    <span className="text-muted small">{sendOptions.audiences.length} seleccionadas</span>
	                  </div>
	                  <div className="text-muted small mt-1">
	                    {recipientEstimate.loading
	                      ? 'Estimando destinatarios…'
	                      : recipientEstimate.error
	                        ? `No se pudo estimar: ${recipientEstimate.error}`
	                        : `Destinatarios estimados (sin bajas, únicos): ${recipientEstimate.total ?? 0}`}
	                  </div>
	                  <div className="d-flex flex-wrap gap-2">
	                    {audiences.length ? audiences.map((a) => {
	                      const active = sendOptions.audiences.includes(a.id);
	                      return (
	                        <button
                          key={a.id}
                          type="button"
                          className={`btn btn-sm ${active ? 'btn-primary' : 'btn-outline-secondary'}`}
                          onClick={() => toggleSendAudience(a.id)}
                        >
                          {a.name}
                        </button>
                      );
                    }) : <span className="text-muted small">No hay audiencias.</span>}
                  </div>
                </div>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Fecha de envío (programar)</label>
                    <input
                      type="date"
                      className="form-control"
                      value={sendOptions.scheduleDate}
                      onChange={(e) => setSendOptions((prev) => ({ ...prev, scheduleDate: e.target.value }))}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Hora</label>
                    <input
                      type="time"
                      className="form-control"
                      value={sendOptions.scheduleTime}
                      onChange={(e) => setSendOptions((prev) => ({ ...prev, scheduleTime: e.target.value }))}
                    />
                    <div className="form-text">Deja la fecha/hora si vas a programar.</div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setSendStepOpen(false)}>Cancelar</button>
                <button
                  className="btn btn-outline-info"
                  onClick={async () => {
                    if (!sendStepCampaign) return;
                    try {
                      const res = await apiFetch(`/api/email-marketing/campaigns/${sendStepCampaign.id}/dry-run`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                        body: JSON.stringify({
                          provider: sendOptions.provider,
                          accountId: sendOptions.accountId ? Number(sendOptions.accountId) : null,
                          audience_ids: sendOptions.audiences,
                          elastic_sender_id: sendOptions.elasticSenderId || null,
                          tracking_base_url: resolveTrackingBaseUrl(),
                          limit: 3
                        })
                      });
                      const data = await parseJsonSafe(res);
                      if (!res.ok) throw new Error(data.message || 'Error dry-run');
                      const lines = [
                        `Destinatarios únicos: ${data.recipients.unique_total}`,
                        `Suprimidos: ${data.recipients.suppressed}`,
                        `Se enviaría a: ${data.recipients.would_send}`,
                        data.blockers.length ? `⚠️ Bloqueantes: ${data.blockers.join(', ')}` : '✅ Sin bloqueantes',
                        data.audiences.missing.length ? `Audiencias inexistentes: ${data.audiences.missing.join(', ')}` : '',
                        data.elastic_sender ? `Sender Elastic: ${data.elastic_sender.from_name || ''} <${data.elastic_sender.from_email}>` : '',
                        '',
                        'Previews (primeros):',
                        ...data.previews.map((p) => `  → ${p.to} · asunto: "${p.subject}" · ${p.html_length} chars`)
                      ].filter(Boolean);
                      alert(lines.join('\n'));
                    } catch (err) {
                      alert(err.message);
                    }
                  }}
                >
                  Dry run
                </button>
                <button className="btn btn-outline-secondary" onClick={handleSaveDraftSendStep}>Guardar borrador</button>
                <button className="btn btn-outline-primary" onClick={handleScheduleSend}>Programar</button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    if (!window.confirm(`¿Enviar ahora la campaña "${sendStepCampaign?.name}" a ${recipientEstimate.total ?? '¿?'} destinatarios? Esta acción no se puede deshacer.`)) return;
                    handleSendNow();
                  }}
                >
                  Enviar ahora
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {resendModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reenviar a no abiertos · {resendModal.campaign?.name}</h5>
                <button className="btn-close" onClick={() => setResendModal((p) => ({ ...p, open: false }))}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info py-2 small">
                  Se enviará una copia de la campaña a <strong>{resendModal.candidates}</strong> destinatarios que <strong>no abrieron ni hicieron clic</strong>.
                  Quedan excluidos los que ya se dieron de baja, han rebotado o están suprimidos.
                </div>
                <div className="mb-3">
                  <label className="form-label small">Motor de envío</label>
                  <select
                    className="form-select"
                    value={resendModal.provider}
                    onChange={(e) => setResendModal((p) => ({ ...p, provider: e.target.value }))}
                  >
                    <option value="smtp">SMTP</option>
                    <option value="elastic">Elastic Email</option>
                  </select>
                </div>
                {resendModal.provider === 'smtp' && (
                  <div className="mb-3">
                    <label className="form-label small">Cuenta SMTP</label>
                    <select
                      className="form-select"
                      value={resendModal.accountId}
                      onChange={(e) => setResendModal((p) => ({ ...p, accountId: e.target.value }))}
                    >
                      <option value="">Selecciona</option>
                      {emailAccounts.map((a) => (
                        <option key={a.id} value={a.id}>{a.from_name || a.from_email} (id {a.id})</option>
                      ))}
                    </select>
                  </div>
                )}
                {resendModal.provider === 'elastic' && (
                  <div className="mb-3">
                    <label className="form-label small">Remitente</label>
                    <select
                      className="form-select"
                      value={resendModal.elasticSenderId}
                      onChange={(e) => setResendModal((p) => ({ ...p, elasticSenderId: e.target.value }))}
                    >
                      <option value="">Por defecto de la cuenta</option>
                      {elasticSenders.map((s) => (
                        <option key={s.id} value={s.id}>{s.name} — {s.from_email}</option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="mb-3">
                  <label className="form-label small">Prefijo de asunto/nombre</label>
                  <input
                    className="form-control"
                    value={resendModal.subjectPrefix}
                    onChange={(e) => setResendModal((p) => ({ ...p, subjectPrefix: e.target.value }))}
                    placeholder="[Reenvío] "
                  />
                  <div className="form-text">Se añade al asunto y al nombre de la nueva campaña duplicada.</div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setResendModal((p) => ({ ...p, open: false }))}>Cancelar</button>
                <button
                  className="btn btn-primary"
                  disabled={resendModal.sending || (resendModal.provider === 'smtp' && !resendModal.accountId)}
                  onClick={async () => {
                    if (!window.confirm(`¿Reenviar a ${resendModal.candidates} destinatarios?`)) return;
                    setResendModal((p) => ({ ...p, sending: true }));
                    try {
                      const res = await apiFetch(`/api/email-marketing/campaigns/${resendModal.campaign.id}/resend-unopened`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                        body: JSON.stringify({
                          provider: resendModal.provider,
                          accountId: resendModal.provider === 'smtp' ? resendModal.accountId : null,
                          elastic_sender_id: resendModal.provider === 'elastic' ? (resendModal.elasticSenderId || null) : null,
                          subjectPrefix: resendModal.subjectPrefix,
                          tracking_base_url: resolveTrackingBaseUrl(),
                          batchSize: 50
                        })
                      });
                      const data = await parseJsonSafe(res);
                      if (res.status === 401) return handleUnauthorized();
                      if (!res.ok) throw new Error(data.message || 'No se pudo reenviar');
                      alert(`Reenvío iniciado. Encolados ${data.queued} (procesados ${data.processed} ahora; el resto los enviará el cron en los próximos minutos).`);
                      setResendModal({ open: false, campaign: null, candidates: 0, provider: 'smtp', accountId: '', elasticSenderId: '', subjectPrefix: '[Reenvío] ', sending: false });
                      fetchCampaigns();
                    } catch (err) {
                      alert(err.message);
                      setResendModal((p) => ({ ...p, sending: false }));
                    }
                  }}
                >
                  {resendModal.sending ? 'Enviando…' : 'Reenviar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {sendersPanelOpen && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Remitentes Elastic</h5>
                <button className="btn-close" onClick={() => setSendersPanelOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info py-2 small">
                  Cada remitente debe estar verificado (SPF + DKIM) en tu cuenta Elastic Email. Usamos una única API key, pero podemos enviar desde varios dominios.
                </div>
                <div className="row g-2 align-items-end mb-3">
                  <div className="col-md-3">
                    <label className="form-label small">Nombre interno</label>
                    <input className="form-control form-control-sm" value={senderForm.name} onChange={(e) => setSenderForm((p) => ({ ...p, name: e.target.value }))} placeholder="Marca A" />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small">From email *</label>
                    <input className="form-control form-control-sm" value={senderForm.from_email} onChange={(e) => setSenderForm((p) => ({ ...p, from_email: e.target.value }))} placeholder="info@dominio.com" />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small">From name</label>
                    <input className="form-control form-control-sm" value={senderForm.from_name} onChange={(e) => setSenderForm((p) => ({ ...p, from_name: e.target.value }))} placeholder="Marca" />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small">Reply-to</label>
                    <input className="form-control form-control-sm" value={senderForm.reply_to} onChange={(e) => setSenderForm((p) => ({ ...p, reply_to: e.target.value }))} />
                  </div>
                  <div className="col-md-2">
                    <div className="form-check mt-2">
                      <input className="form-check-input" type="checkbox" id="senderDefault" checked={senderForm.is_default} onChange={(e) => setSenderForm((p) => ({ ...p, is_default: e.target.checked }))} />
                      <label className="form-check-label small" htmlFor="senderDefault">Por defecto</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      disabled={!senderForm.name || !senderForm.from_email}
                      onClick={async () => {
                        try {
                          const url = senderForm.id
                            ? `/api/email-marketing/elastic-senders/${senderForm.id}`
                            : '/api/email-marketing/elastic-senders';
                          const method = senderForm.id ? 'PUT' : 'POST';
                          const res = await apiFetch(url, {
                            method,
                            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                            body: JSON.stringify(senderForm)
                          });
                          const data = await parseJsonSafe(res);
                          if (!res.ok) throw new Error(data.message || 'Error guardando');
                          setSenderForm({ id: null, name: '', from_email: '', from_name: '', reply_to: '', is_default: false });
                          loadElasticSenders();
                        } catch (err) { alert(err.message); }
                      }}
                    >
                      {senderForm.id ? 'Actualizar' : 'Añadir remitente'}
                    </button>
                    {senderForm.id && (
                      <button type="button" className="btn btn-sm btn-outline-secondary ms-2" onClick={() => setSenderForm({ id: null, name: '', from_email: '', from_name: '', reply_to: '', is_default: false })}>
                        Cancelar edición
                      </button>
                    )}
                  </div>
                </div>
                <table className="table table-sm">
                  <thead>
                    <tr><th>Nombre</th><th>From</th><th>Reply-to</th><th></th><th></th></tr>
                  </thead>
                  <tbody>
                    {elasticSenders.length === 0 && <tr><td colSpan="5" className="text-muted">Aún no hay remitentes.</td></tr>}
                    {elasticSenders.map((s) => (
                      <tr key={s.id}>
                        <td>{s.name}{s.is_default && <span className="badge bg-success ms-2">default</span>}</td>
                        <td>{s.from_name ? `${s.from_name} <${s.from_email}>` : s.from_email}</td>
                        <td>{s.reply_to || '-'}</td>
                        <td><button className="btn btn-sm btn-outline-secondary" onClick={() => setSenderForm({ id: s.id, name: s.name, from_email: s.from_email, from_name: s.from_name || '', reply_to: s.reply_to || '', is_default: !!s.is_default })}>Editar</button></td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={async () => {
                              if (!window.confirm(`¿Eliminar remitente ${s.from_email}?`)) return;
                              try {
                                const res = await apiFetch(`/api/email-marketing/elastic-senders/${s.id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
                                if (!res.ok) { const d = await parseJsonSafe(res); throw new Error(d.message || 'Error'); }
                                loadElasticSenders();
                              } catch (err) { alert(err.message); }
                            }}
                          >
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setSendersPanelOpen(false)}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default EmailMarketingPage;
